import moment from "moment";
import React from 'react';
import newsearchfilter from "../SearchFilterNew.scss"; // Import the SCSS file

// re-check
export const ListingTypeOptions = [
  { label: 'SBTW BRRR SFR Owner Occ', value: 'SBTW1', tag: [] },
  { label: 'SBTW BRRR SFR Non Owner', value: 'SBTW2', tag: [] },
  { label: 'SBTW BRRR Multi Fam', value: 'SBTW3', tag: [] },
  { label: 'SBTW Vacant Land', value: 'SBTW4', tag: [] },
  { label: 'On Market', value: 'M', tag: ['on market', 'mls', 'listed', 'listings', 'sale', 'for sale', 'agent', 'realtor', 'active', 'pending', 'contingent'] },
  { label: 'Vacant', value: 'V', tag: ['vacant', 'usps', 'vacation', 'home', 'empty'] },
  { label: 'Liens', value: 'L', tag: ['liens', 'involuntary'] },
  { label: 'Pre-Foreclosures', value: 'P', tag: ['pre-foreclosure', 'distressed', 'auction', 'lis pendens', 'default', 'notice', "trustee's sale", 'foreclosure'] },
  { label: 'Auctions', value: 'A', tag: ['auctions', 'pre-foreclosure', 'auction', 'date', 'time', 'distressed'] },
  { label: 'Bank Owned', value: 'F', tag: ['bank owned', 'distressed', 'bank'] },
  { label: 'Cash Buyers', value: 'C', tag: ['cash buyers', 'cash', 'money', 'investors', 'buyer'] },
  { label: 'High Equity', value: 'E', tag: ['equity', 'high equity', 'low debt'] },
  { label: 'Free & Clear', value: 'R', tag: ['free & clear', 'no debt', 'no mortgage', 'paid off', 'clear', 'debt free'] },
  { label: 'Bankruptcy', value: 'B', tag: ['bankruptcy', 'chapter 7', 'chapter 13', 'active', 'dismissed', 'broke', 'liquidation'] },
  { label: 'Divorce', value: 'D', tag: ['divorce', 'seperation'] },
  { label: 'Tax Delinquency', value: 'X', tag: ['tax delinquency', 'delinquency', 'delinquent', 'federal', 'property', 'property taxes', 'tax', 'taxes', 'unpaid'] },
  { label: 'Flippers', value: 'I', tag: ['flip', 'flippers', 'sold'] },
  { label: 'Failed Listings', value: 'Z', tag: ['failed listings', 'mls', 'listings', 'removed', 'failure', 'failed', 'fail'] },
  { label: 'Senior Owners', value: 'S', tag: ['senior owners', 'senior', 'old', 'reverse mortgage', 'age'] },
  { label: 'Vacant Land', value: 'VLN', tag: ['vacant', 'land', 'empty', 'plot', 'lot', 'vacant land'] },
  { label: 'Upside Down', value: 'UD', tag: ['upside down', 'equity', 'negative equity', 'underwater'] },
  { label: 'Tired Landlords', value: 'T', tag: ['tired landlords', 'landlord', 'non owner', 'non-owner occupied', 'nonowner', 'rental', 'tenant', 'tired'] },
  { label: 'Zombie Properties', value: 'ZOM', tag: ['vacant', 'pre-foreclosure', 'distressed', 'empty', 'zombie', 'zombie properties'] },
  { label: 'Pre-Probate', value: 'DEC', tag: ['probate', 'pre-Probate', 'preprobate', 'pre probate', 'funeral', 'cemetary', 'deceased', 'owner', 'transfer'] },
];

// Applied Filter screen display here
export const FilterSectionsNew = [
  {
    id: 'LEADLIST',
    title: 'LEAD LIST',
    fields: [
      // { name: 'ownerOccupied', type: 'boolean', label: 'Owner Occupied' },
      { name: 'listingType', type: 'text', label: 'Lead Lists', options: ListingTypeOptions, tooltip: 'Trigger choices are quick ways to target specific motivated seller categories.' },
      // { name: 'vacant', type: 'boolean', label: 'Occupancy Status', options: OccupancyOptions },
    ],
  },
  {
    name: 'PROPERTY',
    title: 'Property Characteristics',
    fields: [
      { name: 'propertyClassCode', type: 'list', label: 'Property Classification(s)', options: PropertyClassOptionsList },
      { name: 'landUseCode', type: 'list', label: 'Property Type(s)', options: [] },
      // { name: 'bedrooms', type: 'combobox', label: 'Bedrooms', options: BedroomOptions },
      // { name: 'bathrooms', type: 'combobox', label: 'Bathrooms', options: BathroomOptions },
      // { name: 'squareFeet', type: 'combobox', label: 'Building Size (SqFt)', options: BuildingSizeOptions },
      // { name: 'lotSquareFeet', type: 'combobox', label: 'Lot Size (SqFt)', options: LotSizeOptions },
      // { name: 'yearBuilt', type: 'combobox', label: 'Year Built', options: YearBuiltOptions },
      // { name: 'propertyFeatures', type: 'list', label: 'Home Features', options: PropertyFeatureOptions },
      // { name: 'units', type: 'combobox', label: 'Unit Number Range', options: NumberUnitOptions },
      // { name: 'stories', type: 'combobox', label: 'Number of Stories', options: NumberStoryOptions },
      // { name: 'schoolDistrict', type: 'text', label: 'School District' },
      // { name: 'hoaPresent', type: 'boolean', label: 'Association (HOA/COA)', options: IncludeExcludeOptions },
    ],
  },
  // {
  //   name: 'MLS',
  //   title: 'MLS Status',
  //   fields: [
  //     { name: 'forSale', type: 'boolean', label: 'On Market' },
  //     { name: 'rental', type: 'boolean', label: 'Listing Type', options: MlsListingTypeOptions },
  //     { name: 'mlsListingStatus', type: 'list', label: 'MLS Status', options: MlsListingStatus },
  //     { name: 'mlsListingDate', type: 'date', label: 'MLS Listing Date', options: MlsStatusDateOptions },
  //     { name: 'daysOnMarket', type: 'combobox', label: 'Days On Market', options: DaysMarketOptions },
  //     { name: 'mlsListingAmount', type: 'combobox', label: 'MLS Listing Amount', options: ListingAmountOptions },
  //     { name: 'belowMarketPrice', type: 'boolean', label: 'Listed Below Market Price' },
  //     { name: 'mlsListingKeyword', type: 'text', label: 'MLS Keyword(s)' },
  //     // { name: 'mlsFailDate', type: 'date', label: 'Failed Listing Date' },
  //     // { name: 'rental', type: 'boolean', label: 'MLS Rental' },
  //   ],
  // },
  // {
  //   name: 'FORECLOSURE',
  //   title: 'Pre-Foreclosure & Bank Owned',
  //   fields: [
  //     { name: 'foreclosureStatus2', type: 'list', label: 'Foreclosure Status', options: ForeclosureStatusOptions },
  //     { name: 'foreclosureRecordingDate', type: 'date', label: 'Foreclosure Recording Date', options: ForeclosureDateOptions },
  //     { name: 'auctionDate', type: 'date', label: 'Auction Date', futureDateEnabled: true, options: ForeclosureDateOptions },
  //     { name: 'openingBidAmount', type: 'combobox', label: 'Opening Bid', options: OpeningAmountOptions },
  //     { name: 'foreclosureReleaseDate', type: 'date', label: 'Pre-Foreclosure Release Date', options: ForeclosureDateOptions },
  //     { name: 'defaultAmount', type: 'combobox', label: 'Default Amount', options: DefaultAmountOptions },
  //     // { name: 'documentTypeCode', type: 'list', label: 'Document Type', options: DocumentTypeCode },
  //   ],
  // },
  // {
  //   name: 'OWNERSHIP',
  //   title: 'Ownership Info',
  //   fields: [
  //     { name: 'ownershipLength', type: 'combobox', label: 'Years of Ownership', options: YearOwnershipOptions },
  //     { name: 'ownerType', type: 'list', label: 'Owner Type', options: OwnershipOptions },
  //     { name: 'saleDate', type: 'date', label: 'Last Sale Date', options: LastSaleDateOptions },
  //     { name: 'saleAmount', type: 'combobox', label: 'Last Sale Price', options: LastSalePriceOptions },
  //     { name: 'propertiesOwned', type: 'combobox', label: 'Number of Properties Owned', options: PropertyOwnedOptions },
  //     { name: 'exemptions', type: 'list', label: 'Tax Exemption Status', options: TaxExemptionOptions },
  //     { name: 'ownerLocation', type: 'list', label: 'Absentee Owner Location', options: OwnerLocationOptions },
  //     // { name: 'ownerDeceasedCode', type: 'list', label: 'Owner Deceased', options: DeceasedOptions },
  //     { name: 'ownerDeceased', type: 'boolean', label: 'Pre-Probate (Deceased Owners)', options: IncludeExcludeOptions },
  //     { name: 'interFamilyTransfer', type: 'boolean', label: 'Intra-Family Transfer', options: IncludeExcludeOptions },
  //     { name: 'missingSaleIncluded', type: 'boolean', label: 'Include Unknown Sale Dates' },
  //   ],
  // },
  // {
  //   name: 'LIEN',
  //   title: 'Lien/Bankruptcy/Divorce Status',
  //   fields: [
  //     { name: 'lienStatus', type: 'list', label: 'Quick Target Status', options: LienStatusOptions },
  //     { name: 'lienTypeCode', type: 'list', label: 'Specific Lien Type', options: LienTypeCode },
  //     { name: 'lienStatusExclude', type: 'list', label: 'Quick Suppress Status', options: LienStatusOptions },
  //     { name: 'lienRecordingDate', type: 'date', label: 'Lien Recording Date', options: LBDRecordDateOptions },
  //     { name: 'bankruptcyRecordingDate', type: 'date', label: 'Bankruptcy Recording Date', options: LBDRecordDateOptions },
  //     { name: 'lienAmount', type: 'combobox', label: 'Lien Amount', options: LienAmountOptions },
  //     { name: 'divorceRecordingDate', type: 'date', label: 'Divorce Filing Date', options: LBDRecordDateOptions },
  //     { name: 'delinquentTaxYear', type: 'combobox', label: 'Tax Delinquent Year', options: YearBuiltOptions },
  //   ],
  // },
  // {
  //   name: 'VALUE',
  //   title: 'Valuation & Equity Info',
  //   fields: [
  //     { name: 'estimatedValue', type: 'combobox', label: 'Estimated Value', options: EstimatedValueOptions },
  //     { name: 'estimatedRentalIncome', type: 'combobox', label: 'Estimated Rental Income', options: RentalIncomeOptions },
  //     { name: 'grossYield', type: 'combobox', label: 'Gross Yield %', options: GrossYieldOptions },
  //     { name: 'estimatedValueGrowth', type: 'combobox', label: 'Growth %', negativeAllowed: true, options: GrowthValueOptions, secondaryOptions: GrowthOverOptions },
  //     { name: 'estimatedValueGrowthPeriod', type: 'text', options: GrowthOverOptions },
  //     { name: 'estimatedEquity', type: 'combobox', label: 'Estimated Equity $', negativeAllowed: true, options: EquityCurrencyOptions },
  //     { name: 'estimatedEquityPercent', type: 'combobox', label: 'Estimated Equity %', negativeAllowed: true, options: EquityPercentOptions },
  //     { name: 'loanToValueRatio', type: 'combobox', label: 'Loan to Value (LTV) %', negativeAllowed: true, options: LoanValueOptions },
  //     { name: 'assessedValue', type: 'combobox', label: 'Assessed Total Value', options: AssessedValueOptions },
  //     { name: 'assessedImprovementValue', type: 'combobox', label: 'Assessed Improvement Value', options: AssessedValueOptions },
  //     { name: 'assessedLandValue', type: 'combobox', label: 'Assessed Land Value', options: AssessedValueOptions },
  //     { name: 'itvRatio', type: 'combobox', label: 'Improvement to Tax Value %', negativeAllowed: true, options: ImprovementTaxOptions },
  //     { name: 'unknownEquityIncluded', type: 'boolean', label: 'Include Unknown Equity' },
  //     { name: 'unknownLtvIncluded', type: 'boolean', label: 'Include Unknown LTV %' },
  //   ],
  // },
  // {
  //   name: 'MORTGAGE',
  //   title: 'Mortgage Info',
  //   fields: [
  //     { name: 'openMortgageQuantity', type: 'list', label: '# of Open Mortgages', options: OpenMortgageOptions },
  //     { name: 'openMortgageBalance', type: 'combobox', label: 'Open Mortgage Remaining Balance', options: RemainBalanceOptions },
  //     { name: 'mortgageLoanCode', type: 'list', label: 'Loan Type(s)', options: LoanTypes },
  //     { name: 'mortgageRecDate', type: 'date', label: 'Mortgage Recording Date', options: MortgageDateOptions },
  //     { name: 'mortgageTotalPayment', type: 'combobox', label: 'Total Monthly Payments', options: MonthlyPaymentOptions },
  //     { name: 'mortgageInterestRate', type: 'combobox', label: 'Interest Rate % (Est.)', options: InterestRateOptions },
  //     { name: 'mortgageFinancingCode', type: 'list', label: 'Interest Rate Type(s)', options: FinancingTypes },
  //     // { name: 'mortgageRefinance', type: 'boolean', label: 'Refinance', options: IncludeExcludeOptions },
  //     // { name: 'mortgageRefinanceDate', type: 'date', label: 'Refinance Date Range' },
  //     // { name: 'mortgageLenderName', type: 'text', label: 'Lender Name(s)', description: 'Separated by "," - 4 character min. per name' },
  //     // { name: 'mortgageMaturityDate', type: 'date', label: 'Last Loan Due Date', futureDateEnabled: true },
  //     { name: 'mortgage1LtvRatio', type: 'combobox', label: '1st Loan to Current Value (1LTV) %', negativeAllowed: true, options: FirstLoanPercentOptions },
  //     { name: 'mortgage1EstimatedEquity', type: 'combobox', label: '1st Loan to Current Value (1LTV) Equity $', negativeAllowed: true, options: FistLoanCurrencyOptions },
  //     { name: 'cashBuyer', type: 'boolean', label: 'Cash Buyer', options: IncludeExcludeOptions },
  //     { name: 'freeClear', type: 'boolean', label: 'Free & Clear', options: IncludeExcludeOptions },
  //     { name: 'mortgageSellerCarried', type: 'boolean', label: 'Seller Carry Back', options: IncludeExcludeOptions },
  //   ],
  // },
  // ...[1, 2, 3, 4].reduce((sections, idx) => ([
  //   ...sections,
  //   {
  //     name: `MORTGAGE${idx}`,
  //     title: `Loan ${idx} Info`,
  //     fields: [
  //       { name: `mortgage${idx}RecordingDate`, type: 'date', label: `Loan ${idx} Origination Date` },
  //       { name: `mortgage${idx}Balance`, type: 'currency', label: `Loan ${idx} Balance` },
  //       { name: `mortgage${idx}LoanCode`, type: 'list', label: 'Loan Type(s)', options: LoanTypes },
  //       { name: `mortgage${idx}LenderName`, type: 'text', label: 'Lender Name(s)', description: 'Separated by "," - Delayed Results Expected' },
  //       { name: `mortgage${idx}InterestRate`, type: 'percent', label: `Loan ${idx} Interest Rate % (Est.)` },
  //       { name: `mortgage${idx}FinancingCode`, type: 'list', label: `Loan ${idx} Interest Rate Type(s)`, options: FinancingTypes },
  //       { name: `mortgage${idx}Payment`, type: 'currency', label: `Loan ${idx} Payment Amount` },
  //       { name: `mortgage${idx}DueDate`, type: 'date', label: `Loan ${idx} Due Date`, futureDateEnabled: true },
  //       { name: `mortgage${idx}Refinance`, type: 'boolean', label: 'Refinance', options: IncludeExcludeOptions },
  //       { name: `mortgage${idx}RefinanceDate`, type: 'date', label: `Refinance ${idx} Date Range` },
  //       { name: `mortgage${idx}Equity`, type: 'boolean', label: 'Equity Loan', options: IncludeExcludeOptions },
  //     ],
  //   },
  // ]), []),
];

export const AppliedFilterList = (fieldName, values) => {
  const matchingObjects = [];
  FilterSectionsNew.forEach((section) => {
    section.fields.forEach((field) => {
      if (field.name === fieldName) {
        const matchingOptions = field.options.filter(option => values.includes(option.value));
        matchingOptions.forEach((option) => {
          matchingObjects.push({
            sectionId: section.id,
            key: field.name,
            showSelectedKey: field.label,
            showSelectedValue: option.label,
            selectedOption: { label: option.label, value: option.value },
          });
        });
      }
    });
  });

  return matchingObjects.length > 0 ? matchingObjects : null;
};

export const leftPanelKeys = {
  LeadLists: 'll',
  PropertyDetails: 'pb',
  PropStreamIntelligence: 'pi',
  MLS: 'mls',
  PreForeclosureBankedOwned: 'pfbo',
  OwnerInformationOccupancy: 'oio',
  LienBankruptcyDivorce: 'lbd',
  ValueEquity: 've',
  Mortgage: 'm',
};

export const RightSideSelecterKeys = {
  LeadLists: 'LEADLIST',
  PropertyDetails: 'PROPERTY',
  PropStreamIntelligence: 'pi',
  MLS: 'mls',
  PreForeclosureBankedOwned: 'pfbo',
  OwnerInformationOccupancy: 'oio',
  LienBankruptcyDivorce: 'lbd',
  ValueEquity: 've',
  Mortgage: 'm',
  // LeadLists : 'll',
};

import { getBrandCode } from 'utils/brand';
const brandCode = getBrandCode();

// re-check
export const leftPanelCategories = [
  {
    key: 'll',
    name: 'Lead Lists',
    description:
      'Quickly search & strategize your next move',
  },
  {
    key: 'pb',
    name: 'Property Details',
    description:
      'Beds, baths, property types, building size, etc.',
  },
  {
    key: 'pi',
    name: brandCode === 'propstream' ? 'PropStream Intelligence' : 'Property Intelligence',
    description:
      'Property Condition and Foreclosure Factor',
  },
  {
    key: 'mls',
    name: 'MLS',
    description:
      'MLS Status, Listing Date and Amount, etc.',
  },
  {
    key: 'pfbo',
    name: 'Pre-Foreclosure & Banked Owned',
    description: 'Pre-Foreclosure Type, Recording Date, Default Amount, etc.',
  },
  {
    key: 'oio',
    name: 'Owner Information & Occupancy',
    description:
      'Owner Type, Location, Last Sale date and Price, etc.',
  },
  {
    key: 'lbd',
    name: 'Lien, Bankruptcy, & Divorce',
    description:
      'Lien, Bankruptcy, and Divorce info',
  },
  {
    key: 've',
    name: 'Value & Equity',
    description: 'LTV, Assessed Improvement Value, etc.',
  },
  {
    key: 'm',
    name: 'Mortgage',
    description: 'Open Mortgages, Remaining Balance, Recording Date, Loan Type, Interest Rate, etc.',
  },
];



export const PropertyClassOptionsList = [
  { label: 'All', value: '' },
  { label: 'Residential', value: 'R' },
  { label: 'Commercial', value: 'C' },
  { label: 'Vacant Land', value: 'V' },
  { label: 'Other', value: 'O,I,A,F,T,E' },
];


// export const ResidentialChildList = [
//   { label: 'Residential Property Types', id:"landUseCode", options : ResidentialPropertyTypeOptions },
//   { label: 'Multi-Family Property Types', id:"multiFamilyPropCode", options :  MultiFamilyPropertyTypesOptions },
// ]

// export const CommercialChildList = [
//   { label: 'Commercial Property Types', id:"landUseCode", options :  CommercialPropertyTypesOptions },
// ]

// export const VacantChildList = [
//   { label: 'Vacant Land Property Types', id:"landUseCode", options :  VacantLandPropertyTypesOptions },
// ]

// export const OthersChildList = [
//   { label: 'Office Property Types', id:"landUseCode", options :  OfficePropertyTypesOptions },
//   { label: 'Industrial Property Types', id:"landUseCode", options :  IndustrialPropertyTypesOptions },
//   { label: 'Agricultural Property Types', id:"landUseCode", options :  AgriculturalPropertyTypesOptions },
//   { label: 'Recreational Property Types', id:"landUseCode", options :  RecreationalPropertyTypesOptions },
//   { label: 'Transportation Property Types', id:"landUseCode", options :  TransportationPropertyTypesOptions },
//   { label: 'Exempt Property Types', id:"landUseCode", options :  ExemptPropertyTypesOptions }
// ]

export const ResidentialPropertyTypeOptions = [
  // 3 should be show always
  { id: 'SFR', name: 'Single Family', classCode: 'R' },
  { id: 'CONDO', name: 'Condo/Townhouse', classCode: 'R' },
  { id: '1006', name: 'Mobile home', classCode: 'R' },
  // part 2
  { id: '1013', name: 'Bungalow (Residential)', classCode: 'R' },
  { id: '1003', name: 'Cluster home (Residential)', classCode: 'R' },
  { id: '1004', name: 'Condominium (Residential)', classCode: 'R' },
  { id: '1018', name: 'Garden Home', classCode: 'R' },
  { id: '1019', name: 'Landominium', classCode: 'R' },
  { id: '1016', name: 'Manufactured, Modular, Pre-Fabricated Homes', classCode: 'R' },
  { id: '1015', name: 'Misc Residential Improvement', classCode: 'R' },
  { id: '1017', name: 'Patio Home', classCode: 'R' },
  { id: '1007', name: 'Row house (Residential)', classCode: 'R' },
  { id: '1008', name: 'Rural Residence (Agricultural)', classCode: 'R' },
  { id: '1012', name: 'Seasonal, Cabin, Vacation Residence', classCode: 'R' },
  { id: '1002', name: 'Townhouse (Residential)', classCode: 'R' },
  { id: '1014', name: 'Zero Lot Line (Residential)', classCode: 'R' },
  // { id: '1100', name: 'Residential Income (General) (Multi-Family)', classCode: 'R' },

];

export const MultiFamilyPropertyTypesOptions = [
  // part-1
  { id: 'MULTI2', name: 'Multi-Family 2-4', classCode: 'R' },
  { id: 'MULTI5', name: 'Multi-Family 5+', classCode: 'R' },
  { id: 'DUPLEX', name: 'Duplex', classCode: 'R' },
  // part-2
  { id: '1105', name: 'Apartment house (100+ units)', classCode: 'R' },
  { id: '1104', name: 'Apartment house (5+ units)', classCode: 'R' },
  { id: '1112', name: 'Apartments (generic)', classCode: 'R' },
  { id: '1108', name: 'Boarding or Rooming House, Apt Hotel, Transient Lodgings', classCode: 'R' },
  { id: '1005', name: 'Cooperative (Residential)', classCode: 'R' },
  { id: '1113', name: 'Dormitory, Group Quarters (Residential)', classCode: 'R' },
  { id: '1111', name: 'Fraternity or Sorority House', classCode: 'R' },
  { id: '1106', name: 'Garden Apt, Court Apt (5+ units)', classCode: 'R' },
  { id: '1107', name: 'High-rise Apartments', classCode: 'R' },
  { id: '1109', name: 'Mobile Home or Trailer Park', classCode: 'R' },
  { id: '1110', name: 'Multi-Family Dwellings (Generic, 2+)', classCode: 'R' },
  { id: '1009', name: 'Planned Unit Development (PUD Residential)', classCode: 'R' },
  { id: '1103', name: 'Quadruplex (4 units, any combination)', classCode: 'R' },
  { id: '1010', name: 'Residential Common Area (Condo/PUD/etc.)', classCode: 'R' },
  { id: '1114', name: 'Residential Condominium Development (Association Assessment)', classCode: 'R' },
  { id: '1100', name: 'Residential Income (General) (Multi-Family)', classCode: 'R' },
  { id: '1901', name: 'Residential Parking Garage', classCode: 'R' },
  { id: '1902', name: 'Residential Storage Space.', classCode: 'R' },
  { id: '1011', name: 'Timeshare (Residential)', classCode: 'R' },
  { id: '1102', name: 'Triplex (3 units, any combination)', classCode: 'R' },
];

export const CommercialPropertyTypesOptions = [
  { id: '2000', name: 'Commercial (General)', classCode: 'C' },
  { id: '2047', name: 'Laundromat (self-service)', classCode: 'C' },
  { id: '2031', name: 'Mini-Warehouse, Storage', classCode: 'C' },
  // part-2
  { id: '2045', name: 'Appliance Store', classCode: 'C' },
  { id: '2024', name: 'Auto repair, auto parts, Garage', classCode: 'C' },
  { id: '2015', name: 'Bakery', classCode: 'C' },
  { id: '2016', name: 'Bar, Tavern', classCode: 'C' },
  { id: '2054', name: 'Bed & Breakfast', classCode: 'C' },
  { id: '2025', name: 'Car wash', classCode: 'C' },
  { id: '2038', name: 'Casino', classCode: 'C' },
  // { id: '2000', name: 'Commercial (General)', classCode: 'C' },
  { id: '2043', name: 'Commercial Building', classCode: 'C' },
  { id: '2052', name: 'Commercial Condominium (not offices)', classCode: 'C' },
  { id: '2044', name: 'Commercial/Office/Residential Mixed Use', classCode: 'C' },
  { id: '2008', name: 'Community Shopping Plaza or Shopping Center, Mini-Mall', classCode: 'C' },
  { id: '2019', name: 'Convenience Store with fuel', classCode: 'C' },
  { id: '2018', name: 'Convenience store ', classCode: 'C' },
  { id: '2032', name: 'Day care, Pre-school (Commercial)', classCode: 'C' },
  { id: '2004', name: 'Department Store (apparel, household goods, furniture)', classCode: 'C' },
  { id: '2005', name: 'Department Store (multi-story)', classCode: 'C' },
  { id: '2013', name: 'Drive-thru Restaurant, Fast Food', classCode: 'C' },
  { id: '2053', name: 'Drug Store or Pharmacy', classCode: 'C' },
  { id: '2026', name: 'Dry Cleaner, Laundry', classCode: 'C' },
  { id: '2050', name: 'Farm Supply & Equipment (Commercial)', classCode: 'C' },
  { id: '2037', name: 'Funeral Home, Mortuary (Commercial)', classCode: 'C' },
  { id: '2051', name: 'Garden Center, Home Improvement DIY', classCode: 'C' },
  { id: '2041', name: 'Gas Station', classCode: 'C' },
  { id: '2006', name: 'Grocery, Supermarket', classCode: 'C' },
  { id: '2034', name: 'Hotel', classCode: 'C' },
  { id: '2040', name: 'Hotel or Motel', classCode: 'C' },
  { id: '2039', name: 'Hotel-Resort', classCode: 'C' },
  { id: '2046', name: 'Kennel', classCode: 'C' },
  // { id: '2047', name: 'Laundromat (self-service)', classCode: 'C' },
  { id: '2017', name: 'Liquor Store', classCode: 'C' },
  // { id: '2031', name: 'Mini-Warehouse, Storage', classCode: 'C' },
  { id: '2033', name: 'Motel', classCode: 'C' },
  { id: '2009', name: 'Neighborhood Shopping Center, Strip Center/Mall, Enterprise Zone', classCode: 'C' },
  { id: '2048', name: 'Nightclub (Cocktail Lounge)', classCode: 'C' },
  { id: '2028', name: 'Nursery, Greenhouse, Florist', classCode: 'C' },
  { id: '2035', name: 'Parking Garage, Parking Structure', classCode: 'C' },
  { id: '2036', name: 'Parking Lot', classCode: 'C' },
  { id: '2030', name: 'Printer - Retail', classCode: 'C' },
  { id: '2007', name: 'Regional Shopping Center or Mall with Anchor store', classCode: 'C' },
  { id: '2012', name: 'Restaurant', classCode: 'C' },
  { id: '2001', name: 'Retail Stores (Personal Services, Photography, Travel)', classCode: 'C' },
  { id: '2027', name: 'Service Shop', classCode: 'C' },
  { id: '2020', name: 'Service station (full service)', classCode: 'C' },
  { id: '2021', name: 'Service station w/convenience store (food mart)', classCode: 'C' },
  { id: '2010', name: 'Shopping Center COMMON AREA parking, park etc.', classCode: 'C' },
  { id: '2002', name: 'Store (multi-story)', classCode: 'C' },
  { id: '2003', name: 'Store/Office (mixed use)', classCode: 'C' },
  { id: '2042', name: 'Stores & Apartments', classCode: 'C' },
  { id: '2014', name: 'Take-out Restaurant', classCode: 'C' },
  { id: '2022', name: 'Truck stop (fuel and diner)', classCode: 'C' },
  { id: '2023', name: 'Vehicle Rentals, Vehicle Sales', classCode: 'C' },
  { id: '2011', name: 'Veterinary or Animal Hospital', classCode: 'C' },
  { id: '2029', name: 'Wholesale Outlet, Franchise Discount Store', classCode: 'C' },
  { id: '10', name: 'Miscellaneous (General)', classCode: 'C' },
  { id: '514', name: 'Aircraft', classCode: 'C' },
  { id: '532', name: 'Structures on leased land', classCode: 'C' },

];

export const VacantLandPropertyTypesOptions = [
  { id: '8001', name: 'Residential-Vacant Land', classCode: 'V' },
  { id: '8007', name: 'Multi-Family-Vacant Land', classCode: 'V' },
  { id: '8000', name: 'Vacant Land (General)', classCode: 'V' },

  { id: '8013', name: 'Abandoned Site, Contaminated Site', classCode: 'V' },
  { id: '8008', name: 'Agricultural-Unimproved Vacant Land', classCode: 'V' },
  { id: '8504', name: 'Centrally Assessed', classCode: 'V' },
  { id: '8002', name: 'Commercial-Vacant Land', classCode: 'V' },
  { id: '8006', name: 'Government-Vacant Land', classCode: 'V' },
  { id: '8003', name: 'Industrial-Vacant Land', classCode: 'V' },
  { id: '8005', name: 'Institutional-Vacant Land', classCode: 'V' },
  // { id: '8007', name: 'Multi-Family-Vacant Land', classCode: 'V' },
  { id: '8004', name: 'Private Preserve, Open Space-Vacant Land (Forest Land, Conservation)', classCode: 'V' },
  { id: '8010', name: 'Recreational-Vacant Land', classCode: 'V' },
  { id: '8503', name: 'Redevelopment Agency or Zone', classCode: 'V' },
  { id: '8502', name: 'Regulating Districts & Assessments; Tax Abatement', classCode: 'V' },
  // { id: '8001', name: 'Residential-Vacant Land', classCode: 'V' },
  { id: '8501', name: 'SBE - Special Assessments', classCode: 'V' },
  { id: '8500', name: 'Special Purpose', classCode: 'V' },
  { id: '8014', name: 'Under Construction', classCode: 'V' },
  { id: '8012', name: 'Unusable Land (Remnant, Steep, etc.)', classCode: 'V' },
  // { id: '8000', name: 'Vacant Land (General)', classCode: 'V' },
  { id: '8009', name: 'Waste Land, Marsh, Swamp', classCode: 'V' },
  { id: '8011', name: 'Water Area (Lakes; River; Shore)', classCode: 'V' },

];

export const OfficePropertyTypesOptions = [
  { id: '3000', name: 'Commercial Office (General)', classCode: 'O' },
  { id: '3010', name: 'Mixed Use (Commercial/Industrial)', classCode: 'O' },
  { id: '3003', name: 'Office Bldg (General)', classCode: 'O' },
  //
  // { id: '3000', name: 'Commercial Office (General)', classCode: 'O' },
  { id: '3011', name: 'Common Area (commercial)', classCode: 'O' },
  { id: '3008', name: 'Condominium Offices', classCode: 'O' },
  { id: '3005', name: 'Dental Bldg', classCode: 'O' },
  { id: '3007', name: 'Financial Bldg', classCode: 'O' },
  { id: '3006', name: 'Medical Bldg', classCode: 'O' },
  // { id: '3010', name: 'Mixed Use (Commercial/Industrial)', classCode: 'O' },
  { id: '3012', name: 'Mobile Commercial Units', classCode: 'O' },
  // { id: '3003', name: 'Office Bldg (General)', classCode: 'O' },
  { id: '3004', name: 'Office Bldg (multi-story)', classCode: 'O' },
  { id: '3001', name: 'Professional Bldg (legal; insurance; real estate; etc.)', classCode: 'O' },
  { id: '3002', name: 'Professional Bldg (multi-story)', classCode: 'O' },
  { id: '3009', name: 'Skyscraper/High-rise (Commercial Offices)', classCode: 'O' },
];


export const IndustrialPropertyTypesOptions = [
  { id: '5000', name: 'Industrial (General)', classCode: 'I' },
  { id: '5013', name: 'Multi-Tenant Industrial Bldg', classCode: 'I' },
  { id: '5003', name: 'Warehouse (Industrial)', classCode: 'I' },
  //
  { id: '5006', name: 'Assembly (light industrial)', classCode: 'I' },
  { id: '6020', name: 'Cannery', classCode: 'I' },
  { id: '6018', name: 'Chemical', classCode: 'I' },
  { id: '6024', name: 'Cold Storage', classCode: 'I' },
  { id: '5020', name: 'Common Area (Industrial)', classCode: 'I' },
  { id: '5009', name: 'Communications', classCode: 'I' },
  { id: '5010', name: 'Condominiums (Industrial)', classCode: 'I' },
  { id: '5019', name: 'Construction/Contracting Services (Industrial)', classCode: 'I' },
  { id: '6005', name: 'Distillery, Brewery, Bottling', classCode: 'I' },
  { id: '6002', name: 'Distribution Warehouse (Regional)', classCode: 'I' },
  { id: '6023', name: 'Dump Site', classCode: 'I' },
  { id: '6008', name: 'Factory (medium)', classCode: 'I' },
  { id: '5005', name: 'Food Packing, Packing Plant', classCode: 'I' },
  { id: '5007', name: 'Food Processing ', classCode: 'I' },
  { id: '6019', name: 'Foundry, Industrial Plant', classCode: 'I' },
  { id: '6021', name: 'Gasoline, Fuel Bulk Storage', classCode: 'I' },
  { id: '6022', name: 'Grain Elevator', classCode: 'I' },
  { id: '6000', name: 'Heavy Industrial (General)', classCode: 'I' },
  { id: '6015', name: 'Heavy Manufacturing', classCode: 'I' },
  // { id: '5000', name: 'Industrial (General)', classCode: 'I' },
  { id: '5018', name: 'Industrial Loft Building, Loft Building', classCode: 'I' },
  { id: '5012', name: 'Industrial Park', classCode: 'I' },
  { id: '6016', name: 'Labor Camps (Industrial)', classCode: 'I' },
  { id: '5011', name: 'Laboratory, Research and Development Facility, Cosmetics, Pharmaceutical', classCode: 'I' },
  { id: '5002', name: 'Light Industrial', classCode: 'I' },
  { id: '5015', name: 'Lumber & Wood Product MFG (including furniture)', classCode: 'I' },
  { id: '6010', name: 'Lumberyard, Building Materials', classCode: 'I' },
  { id: '5001', name: 'Manufacturing (light)', classCode: 'I' },
  { id: '5014', name: 'Marine Facility/Boat Repairs (small craft or sailboat)', classCode: 'I' },
  { id: '6007', name: 'Mill', classCode: 'I' },
  { id: '6003', name: 'Mining', classCode: 'I' },
  { id: '5016', name: 'Paper Product MFG & related products', classCode: 'I' },
  { id: '5017', name: 'Printing & Publishing (Light Industrial)', classCode: 'I' },
  { id: '6009', name: 'Processing Plant', classCode: 'I' },
  { id: '6014', name: 'Quarries', classCode: 'I' },
  { id: '5008', name: 'Recycling plant', classCode: 'I' },
  { id: '6006', name: 'Refinery, Petroleum Products', classCode: 'I' },
  { id: '6011', name: 'Shipyard/Storage - Built or Repaired (seagoing vessels)', classCode: 'I' },
  { id: '6012', name: 'Slaughter House, Stockyard', classCode: 'I' },
  { id: '6004', name: 'Storage yard (junk; auto wrecking, salvage)', classCode: 'I' },
  { id: '5004', name: 'Storage yard, Open Storage (light equipment, material)', classCode: 'I' },
  { id: '6025', name: 'Sugar Refinery', classCode: 'I' },
  { id: '6001', name: 'Transportation', classCode: 'I' },
  // { id: '5003', name: 'Warehouse (Industrial)', classCode: 'I' },
  { id: '6013', name: 'Waste Disposal, Sewage, Treatment facility', classCode: 'I' },
  { id: '6017', name: 'Winery', classCode: 'I' },
];

export const AgriculturalPropertyTypesOptions = [
  { id: '7000', name: 'Agricultural / Rural', classCode: 'A' },
  { id: '7022', name: 'Natural Resources', classCode: 'A' },
  { id: '7001', name: 'Farm land ', classCode: 'A' },

  // { id: '7000', name: 'Agricultural / Rural', classCode: 'A' },
  { id: '7004', name: 'Crop, Field Crops, Row Crops (all soil classes)', classCode: 'A' },
  { id: '7008', name: 'Dairy Farm', classCode: 'A' },
  { id: '7011', name: 'Desert or Barren Land', classCode: 'A' },
  // { id: '7001', name: 'Farm land ', classCode: 'A' },
  { id: '7015', name: 'Feedlots', classCode: 'A' },
  { id: '7014', name: 'Grove (Agricultural)', classCode: 'A' },
  { id: '7017', name: 'Horticulture, Growing Houses (Agricultural)', classCode: 'A' },
  { id: '7021', name: 'Irrigation, Flood Control', classCode: 'A' },
  { id: '7016', name: 'Livestock', classCode: 'A' },
  { id: '7013', name: 'Misc. Structures - Ranch, Farm, Fixtures', classCode: 'A' },
  // { id: '7022', name: 'Natural Resources', classCode: 'A' },
  { id: '7005', name: 'Orchard (fruit; nut)', classCode: 'A' },
  { id: '7012', name: 'Pasture, Meadow', classCode: 'A' },
  { id: '7007', name: 'Poultry Farm', classCode: 'A' },
  { id: '7002', name: 'Ranch', classCode: 'A' },
  { id: '7003', name: 'Range land (grazing)', classCode: 'A' },
  { id: '7020', name: 'Reservoir, Water Supply', classCode: 'A' },
  { id: '7023', name: 'Rural Improved / Non-Residential', classCode: 'A' },
  { id: '7009', name: 'Timberland, Forest, Trees (Agricultural)', classCode: 'A' },
  { id: '7019', name: 'Truck Crops', classCode: 'A' },
  { id: '7006', name: 'Vineyard (Agricultural)', classCode: 'A' },
  { id: '7018', name: 'Well Site (Agricultural)', classCode: 'A' },
  { id: '7010', name: 'Wildlife Refuge', classCode: 'A' },

];

export const RecreationalPropertyTypesOptions = [
  { id: '4027', name: 'Park, Playground, Picnic Area', classCode: 'F' },
  { id: '4000', name: 'Recreational/Entertainment (General)', classCode: 'F' },
  { id: '4028', name: 'Golf Course', classCode: 'F' },
  // step-2
  { id: '4022', name: 'Amusement Park, Tourist Attraction', classCode: 'F' },
  { id: '4005', name: 'Arcades (Amusement)', classCode: 'F' },
  { id: '4011', name: 'Arenas, Convention Center', classCode: 'F' },
  { id: '4012', name: 'Auditoriums', classCode: 'F' },
  { id: '4003', name: 'Boat slips, Marina, Yacht Club, Boat Landing', classCode: 'F' },
  { id: '4004', name: 'Bowling Alley', classCode: 'F' },
  { id: '4018', name: 'Campground, RV Park', classCode: 'F' },
  { id: '4007', name: 'Clubs, Lodges, Professional Associations', classCode: 'F' },
  { id: '4009', name: 'Country Club', classCode: 'F' },
  { id: '4016', name: 'Dance Hall', classCode: 'F' },
  { id: '4021', name: 'Drive-In Theater', classCode: 'F' },
  { id: '4019', name: 'Fairgrounds', classCode: 'F' },
  { id: '4024', name: 'Fish Camps, Game Club, Target Shooting', classCode: 'F' },
  { id: '4031', name: 'Go-carts, Miniature Golf, Water slides', classCode: 'F' },
  // { id: '4028', name: 'Golf Course', classCode: 'F' },
  { id: '4013', name: 'Golf Driving Range', classCode: 'F' },
  { id: '4015', name: 'Gym, Health Spa', classCode: 'F' },
  { id: '4008', name: 'Museums, Library, Art Gallery', classCode: 'F' },
  { id: '4025', name: 'Outdoor Recreation: Beach, Mountain, Desert', classCode: 'F' },
  // { id: '4027', name: 'Park, Playground, Picnic Area', classCode: 'F' },
  { id: '4023', name: 'Piers, Wharf ', classCode: 'F' },
  { id: '4026', name: 'Pool Hall, Billiard Parlor', classCode: 'F' },
  { id: '4002', name: 'Public Swimming Pool', classCode: 'F' },
  { id: '4014', name: 'Race track ', classCode: 'F' },
  { id: '4029', name: 'Racquet or Tennis Court', classCode: 'F' },
  { id: '4001', name: 'Recreation Center', classCode: 'F' },
  // { id: '4000', name: 'Recreational/Entertainment (General)', classCode: 'F' },
  { id: '4017', name: 'Riding Stable, Trails', classCode: 'F' },
  { id: '4006', name: 'Skating rink, Ice Skating, Roller Skating', classCode: 'F' },
  { id: '4010', name: 'Stadiums', classCode: 'F' },
  { id: '4020', name: 'Theater', classCode: 'F' },
  { id: '4030', name: 'Zoo', classCode: 'F' },
];
export const TransportationPropertyTypesOptions = [
  { id: '6500', name: 'Transportation & Communications (General)', classCode: 'T' },
  { id: '6505', name: 'Bus Terminal', classCode: 'T' },
  { id: '6508', name: 'Truck Terminal (Motor Freight)', classCode: 'T' },
  // part-2
  { id: '6501', name: 'Airport & related', classCode: 'T' },
  // { id: '6505', name: 'Bus Terminal', classCode: 'T' },
  { id: '6509', name: 'Cable TV Station Communications', classCode: 'T' },
  { id: '6512', name: 'Commercial Auto Transportation/Storage', classCode: 'T' },
  { id: '6503', name: 'Freeways, State Hwys', classCode: 'T' },
  { id: '6510', name: 'Harbor & Marine Transportation', classCode: 'T' },
  { id: '6511', name: 'Microwave', classCode: 'T' },
  { id: '6513', name: 'Pollution Control', classCode: 'T' },
  { id: '6507', name: 'Radio or TV Station Communications', classCode: 'T' },
  { id: '6502', name: 'Railroad & related', classCode: 'T' },
  { id: '6504', name: 'Roads, Streets, Bridges', classCode: 'T' },
  { id: '6506', name: 'Telegraph, Telephone Communications', classCode: 'T' },
  // { id: '6500', name: 'Transportation & Communications (General)', classCode: 'T' },
  // { id: '6508', name: 'Truck Terminal (Motor Freight)', classCode: 'T' },
];

export const ExemptPropertyTypesOptions = [
  { id: '9000', name: 'Exempt (full or partial)', classCode: 'E' },
  { id: '9202', name: 'Forest (park; reserve; recreation, conservation)', classCode: 'E' },
  { id: '9215', name: 'Community Center', classCode: 'E' },

  // part-2
  { id: '9108', name: 'Cemetery (Exempt)', classCode: 'E' },
  { id: '9110', name: 'Charitable organization', classCode: 'E' },
  { id: '9107', name: 'Children\'s Home, Orphanage', classCode: 'E' },
  { id: '9210', name: 'City, Municipal, Town, Village Owned', classCode: 'E' },
  // { id: '9215', name: 'Community Center', classCode: 'E' },
  { id: '9218', name: 'Correctional Facility, Jails, Prisons, Insane Asylum', classCode: 'E' },
  { id: '9211', name: 'County Owned', classCode: 'E' },
  { id: '9109', name: 'Crematorium, Mortuary (Exempt)', classCode: 'E' },
  { id: '9206', name: 'Cultural, Historical', classCode: 'E' },
  { id: '9103', name: 'Educational - PRIVATE', classCode: 'E' },
  { id: '9204', name: 'Educational Colleges, University-PUBLIC', classCode: 'E' },
  { id: '9208', name: 'Emergency (Police; Fire; etc.)', classCode: 'E' },
  // { id: '9000', name: 'Exempt (full or partial)', classCode: 'E' },
  { id: '9213', name: 'Federal Property', classCode: 'E' },
  // { id: '9202', name: 'Forest (park; reserve; recreation, conservation)', classCode: 'E' },
  { id: '9200', name: 'Governmental/Public Use (General)', classCode: 'E' },
  { id: '9207', name: 'Govt. Administrative Office', classCode: 'E' },
  { id: '9309', name: 'Historical District', classCode: 'E' },
  { id: '9304', name: 'Historical Office', classCode: 'E' },
  { id: '9308', name: 'Historical Park, Site, Misc.', classCode: 'E' },
  { id: '9307', name: 'Historical Recreation, Entertainment', classCode: 'E' },
  { id: '9301', name: 'Historical Residence', classCode: 'E' },
  { id: '9302', name: 'Historical Retail', classCode: 'E' },
  { id: '9305', name: 'Historical Transient Lodging (hotel/motel)', classCode: 'E' },
  { id: '9303', name: 'Historical Warehouse', classCode: 'E' },
  { id: '9300', name: 'Historical-PRIVATE (General)', classCode: 'E' },
  { id: '9104', name: 'Hospital-PRIVATE', classCode: 'E' },
  { id: '9219', name: 'Hospital-PUBLIC', classCode: 'E' },
  { id: '9001', name: 'Indian Lands', classCode: 'E' },
  { id: '9100', name: 'Institutional (General)', classCode: 'E' },
  { id: '9105', name: 'Medical Clinic', classCode: 'E' },
  { id: '9201', name: 'Military', classCode: 'E' },
  { id: '9209', name: 'Other exempt property', classCode: 'E' },
  { id: '9102', name: 'Parochial School, Private School', classCode: 'E' },
  { id: '9205', name: 'Post Office', classCode: 'E' },
  { id: '9112', name: 'Private Utility', classCode: 'E' },
  { id: '9214', name: 'Public Health Care Facility', classCode: 'E' },
  { id: '9203', name: 'Public School', classCode: 'E' },
  { id: '9216', name: 'Public Utility', classCode: 'E' },
  { id: '9111', name: 'Recreational Non-Taxable (Camps, Boy Scouts)', classCode: 'E' },
  { id: '9101', name: 'Religious, Church, Worship', classCode: 'E' },
  { id: '9106', name: 'Retired, Handicap, Convalescent, Nursing Home', classCode: 'E' },
  { id: '9212', name: 'State Owned', classCode: 'E' },
  { id: '9217', name: 'Welfare, Social Service, Low Income Housing (Exempt)', classCode: 'E' },

];

export const PropertyTypesNew = [
  // { id: '7000', name: 'Agricultural / Rural', classCode: 'A' },
  { id: '7004', name: 'Crop, Field Crops, Row Crops (all soil classes)', classCode: 'A' },
  { id: '7008', name: 'Dairy Farm', classCode: 'A' },
  { id: '7011', name: 'Desert or Barren Land', classCode: 'A' },
  // { id: '7001', name: 'Farm land ', classCode: 'A' },
  { id: '7015', name: 'Feedlots', classCode: 'A' },
  { id: '7014', name: 'Grove (Agricultural)', classCode: 'A' },
  { id: '7017', name: 'Horticulture, Growing Houses (Agricultural)', classCode: 'A' },
  { id: '7021', name: 'Irrigation, Flood Control', classCode: 'A' },
  { id: '7016', name: 'Livestock', classCode: 'A' },
  { id: '7013', name: 'Misc. Structures - Ranch, Farm, Fixtures', classCode: 'A' },
  // { id: '7022', name: 'Natural Resources', classCode: 'A' },
  { id: '7005', name: 'Orchard (fruit; nut)', classCode: 'A' },
  { id: '7012', name: 'Pasture, Meadow', classCode: 'A' },
  { id: '7007', name: 'Poultry Farm', classCode: 'A' },
  { id: '7002', name: 'Ranch', classCode: 'A' },
  { id: '7003', name: 'Range land (grazing)', classCode: 'A' },
  { id: '7020', name: 'Reservoir, Water Supply', classCode: 'A' },
  { id: '7023', name: 'Rural Improved / Non-Residential', classCode: 'A' },
  { id: '7009', name: 'Timberland, Forest, Trees (Agricultural)', classCode: 'A' },
  { id: '7019', name: 'Truck Crops', classCode: 'A' },
  { id: '7006', name: 'Vineyard (Agricultural)', classCode: 'A' },
  { id: '7018', name: 'Well Site (Agricultural)', classCode: 'A' },
  { id: '7010', name: 'Wildlife Refuge', classCode: 'A' },
  { id: '2045', name: 'Appliance Store', classCode: 'C' },
  { id: '2024', name: 'Auto repair, auto parts, Garage', classCode: 'C' },
  { id: '2015', name: 'Bakery', classCode: 'C' },
  { id: '2016', name: 'Bar, Tavern', classCode: 'C' },
  { id: '2054', name: 'Bed & Breakfast', classCode: 'C' },
  { id: '2025', name: 'Car wash', classCode: 'C' },
  { id: '2038', name: 'Casino', classCode: 'C' },
  { id: '2000', name: 'Commercial (General)', classCode: 'C' },
  { id: '2043', name: 'Commercial Building', classCode: 'C' },
  { id: '2052', name: 'Commercial Condominium (not offices)', classCode: 'C' },
  { id: '2044', name: 'Commercial/Office/Residential Mixed Use', classCode: 'C' },
  { id: '2008', name: 'Community Shopping Plaza or Shopping Center, Mini-Mall', classCode: 'C' },
  { id: '2019', name: 'Convenience Store with fuel', classCode: 'C' },
  { id: '2018', name: 'Convenience store ', classCode: 'C' },
  { id: '2032', name: 'Day care, Pre-school (Commercial)', classCode: 'C' },
  { id: '2004', name: 'Department Store (apparel, household goods, furniture)', classCode: 'C' },
  { id: '2005', name: 'Department Store (multi-story)', classCode: 'C' },
  { id: '2013', name: 'Drive-thru Restaurant, Fast Food', classCode: 'C' },
  { id: '2053', name: 'Drug Store or Pharmacy', classCode: 'C' },
  { id: '2026', name: 'Dry Cleaner, Laundry', classCode: 'C' },
  { id: '2050', name: 'Farm Supply & Equipment (Commercial)', classCode: 'C' },
  { id: '2037', name: 'Funeral Home, Mortuary (Commercial)', classCode: 'C' },
  { id: '2051', name: 'Garden Center, Home Improvement DIY', classCode: 'C' },
  { id: '2041', name: 'Gas Station', classCode: 'C' },
  { id: '2006', name: 'Grocery, Supermarket', classCode: 'C' },
  { id: '2034', name: 'Hotel', classCode: 'C' },
  { id: '2040', name: 'Hotel or Motel', classCode: 'C' },
  { id: '2039', name: 'Hotel-Resort', classCode: 'C' },
  { id: '2046', name: 'Kennel', classCode: 'C' },
  { id: '2047', name: 'Laundromat (self-service)', classCode: 'C' },
  { id: '2017', name: 'Liquor Store', classCode: 'C' },
  { id: '2031', name: 'Mini-Warehouse, Storage', classCode: 'C' },
  { id: '2033', name: 'Motel', classCode: 'C' },
  { id: '2009', name: 'Neighborhood Shopping Center, Strip Center/Mall, Enterprise Zone', classCode: 'C' },
  { id: '2048', name: 'Nightclub (Cocktail Lounge)', classCode: 'C' },
  { id: '2028', name: 'Nursery, Greenhouse, Florist', classCode: 'C' },
  { id: '2035', name: 'Parking Garage, Parking Structure', classCode: 'C' },
  { id: '2036', name: 'Parking Lot', classCode: 'C' },
  { id: '2030', name: 'Printer - Retail', classCode: 'C' },
  { id: '2007', name: 'Regional Shopping Center or Mall with Anchor store', classCode: 'C' },
  { id: '2012', name: 'Restaurant', classCode: 'C' },
  { id: '2001', name: 'Retail Stores (Personal Services, Photography, Travel)', classCode: 'C' },
  { id: '2027', name: 'Service Shop', classCode: 'C' },
  { id: '2020', name: 'Service station (full service)', classCode: 'C' },
  { id: '2021', name: 'Service station w/convenience store (food mart)', classCode: 'C' },
  { id: '2010', name: 'Shopping Center COMMON AREA parking, park etc.', classCode: 'C' },
  { id: '2002', name: 'Store (multi-story)', classCode: 'C' },
  { id: '2003', name: 'Store/Office (mixed use)', classCode: 'C' },
  { id: '2042', name: 'Stores & Apartments', classCode: 'C' },
  { id: '2014', name: 'Take-out Restaurant', classCode: 'C' },
  { id: '2022', name: 'Truck stop (fuel and diner)', classCode: 'C' },
  { id: '2023', name: 'Vehicle Rentals, Vehicle Sales', classCode: 'C' },
  { id: '2011', name: 'Veterinary or Animal Hospital', classCode: 'C' },
  { id: '2029', name: 'Wholesale Outlet, Franchise Discount Store', classCode: 'C' },
  { id: '9108', name: 'Cemetery (Exempt)', classCode: 'E' },
  { id: '9110', name: 'Charitable organization', classCode: 'E' },
  { id: '9107', name: 'Children\'s Home, Orphanage', classCode: 'E' },
  { id: '9210', name: 'City, Municipal, Town, Village Owned', classCode: 'E' },
  // { id: '9215', name: 'Community Center', classCode: 'E' },
  { id: '9218', name: 'Correctional Facility, Jails, Prisons, Insane Asylum', classCode: 'E' },
  { id: '9211', name: 'County Owned', classCode: 'E' },
  { id: '9109', name: 'Crematorium, Mortuary (Exempt)', classCode: 'E' },
  { id: '9206', name: 'Cultural, Historical', classCode: 'E' },
  { id: '9103', name: 'Educational - PRIVATE', classCode: 'E' },
  { id: '9204', name: 'Educational Colleges, University-PUBLIC', classCode: 'E' },
  { id: '9208', name: 'Emergency (Police; Fire; etc.)', classCode: 'E' },
  // { id: '9000', name: 'Exempt (full or partial)', classCode: 'E' },
  { id: '9213', name: 'Federal Property', classCode: 'E' },
  // { id: '9202', name: 'Forest (park; reserve; recreation, conservation)', classCode: 'E' },
  { id: '9200', name: 'Governmental/Public Use (General)', classCode: 'E' },
  { id: '9207', name: 'Govt. Administrative Office', classCode: 'E' },
  { id: '9309', name: 'Historical District', classCode: 'E' },
  { id: '9304', name: 'Historical Office', classCode: 'E' },
  { id: '9308', name: 'Historical Park, Site, Misc.', classCode: 'E' },
  { id: '9307', name: 'Historical Recreation, Entertainment', classCode: 'E' },
  { id: '9301', name: 'Historical Residence', classCode: 'E' },
  { id: '9302', name: 'Historical Retail', classCode: 'E' },
  { id: '9305', name: 'Historical Transient Lodging (hotel/motel)', classCode: 'E' },
  { id: '9303', name: 'Historical Warehouse', classCode: 'E' },
  { id: '9300', name: 'Historical-PRIVATE (General)', classCode: 'E' },
  { id: '9104', name: 'Hospital-PRIVATE', classCode: 'E' },
  { id: '9219', name: 'Hospital-PUBLIC', classCode: 'E' },
  { id: '9001', name: 'Indian Lands', classCode: 'E' },
  { id: '9100', name: 'Institutional (General)', classCode: 'E' },
  { id: '9105', name: 'Medical Clinic', classCode: 'E' },
  { id: '9201', name: 'Military', classCode: 'E' },
  { id: '9209', name: 'Other exempt property', classCode: 'E' },
  { id: '9102', name: 'Parochial School, Private School', classCode: 'E' },
  { id: '9205', name: 'Post Office', classCode: 'E' },
  { id: '9112', name: 'Private Utility', classCode: 'E' },
  { id: '9214', name: 'Public Health Care Facility', classCode: 'E' },
  { id: '9203', name: 'Public School', classCode: 'E' },
  { id: '9216', name: 'Public Utility', classCode: 'E' },
  { id: '9111', name: 'Recreational Non-Taxable (Camps, Boy Scouts)', classCode: 'E' },
  { id: '9101', name: 'Religious, Church, Worship', classCode: 'E' },
  { id: '9106', name: 'Retired, Handicap, Convalescent, Nursing Home', classCode: 'E' },
  { id: '9212', name: 'State Owned', classCode: 'E' },
  { id: '9217', name: 'Welfare, Social Service, Low Income Housing (Exempt)', classCode: 'E' },
  { id: '4022', name: 'Amusement Park, Tourist Attraction', classCode: 'F' },
  { id: '4005', name: 'Arcades (Amusement)', classCode: 'F' },
  { id: '4011', name: 'Arenas, Convention Center', classCode: 'F' },
  { id: '4012', name: 'Auditoriums', classCode: 'F' },
  { id: '4003', name: 'Boat slips, Marina, Yacht Club, Boat Landing', classCode: 'F' },
  { id: '4004', name: 'Bowling Alley', classCode: 'F' },
  { id: '4018', name: 'Campground, RV Park', classCode: 'F' },
  { id: '4007', name: 'Clubs, Lodges, Professional Associations', classCode: 'F' },
  { id: '4009', name: 'Country Club', classCode: 'F' },
  { id: '4016', name: 'Dance Hall', classCode: 'F' },
  { id: '4021', name: 'Drive-In Theater', classCode: 'F' },
  { id: '4019', name: 'Fairgrounds', classCode: 'F' },
  { id: '4024', name: 'Fish Camps, Game Club, Target Shooting', classCode: 'F' },
  { id: '4031', name: 'Go-carts, Miniature Golf, Water slides', classCode: 'F' },
  // { id: '4028', name: 'Golf Course', classCode: 'F' },
  { id: '4013', name: 'Golf Driving Range', classCode: 'F' },
  { id: '4015', name: 'Gym, Health Spa', classCode: 'F' },
  { id: '4008', name: 'Museums, Library, Art Gallery', classCode: 'F' },
  { id: '4025', name: 'Outdoor Recreation: Beach, Mountain, Desert', classCode: 'F' },
  // { id: '4027', name: 'Park, Playground, Picnic Area', classCode: 'F' },
  { id: '4023', name: 'Piers, Wharf ', classCode: 'F' },
  { id: '4026', name: 'Pool Hall, Billiard Parlor', classCode: 'F' },
  { id: '4002', name: 'Public Swimming Pool', classCode: 'F' },
  { id: '4014', name: 'Race track ', classCode: 'F' },
  { id: '4029', name: 'Racquet or Tennis Court', classCode: 'F' },
  { id: '4001', name: 'Recreation Center', classCode: 'F' },
  // { id: '4000', name: 'Recreational/Entertainment (General)', classCode: 'F' },
  { id: '4017', name: 'Riding Stable, Trails', classCode: 'F' },
  { id: '4006', name: 'Skating rink, Ice Skating, Roller Skating', classCode: 'F' },
  { id: '4010', name: 'Stadiums', classCode: 'F' },
  { id: '4020', name: 'Theater', classCode: 'F' },
  { id: '4030', name: 'Zoo', classCode: 'F' },
  { id: '5006', name: 'Assembly (light industrial)', classCode: 'I' },
  { id: '6020', name: 'Cannery', classCode: 'I' },
  { id: '6018', name: 'Chemical', classCode: 'I' },
  { id: '6024', name: 'Cold Storage', classCode: 'I' },
  { id: '5020', name: 'Common Area (Industrial)', classCode: 'I' },
  { id: '5009', name: 'Communications', classCode: 'I' },
  { id: '5010', name: 'Condominiums (Industrial)', classCode: 'I' },
  { id: '5019', name: 'Construction/Contracting Services (Industrial)', classCode: 'I' },
  { id: '6005', name: 'Distillery, Brewery, Bottling', classCode: 'I' },
  { id: '6002', name: 'Distribution Warehouse (Regional)', classCode: 'I' },
  { id: '6023', name: 'Dump Site', classCode: 'I' },
  { id: '6008', name: 'Factory (medium)', classCode: 'I' },
  { id: '5005', name: 'Food Packing, Packing Plant', classCode: 'I' },
  { id: '5007', name: 'Food Processing ', classCode: 'I' },
  { id: '6019', name: 'Foundry, Industrial Plant', classCode: 'I' },
  { id: '6021', name: 'Gasoline, Fuel Bulk Storage', classCode: 'I' },
  { id: '6022', name: 'Grain Elevator', classCode: 'I' },
  { id: '6000', name: 'Heavy Industrial (General)', classCode: 'I' },
  { id: '6015', name: 'Heavy Manufacturing', classCode: 'I' },
  // { id: '5000', name: 'Industrial (General)', classCode: 'I' },
  { id: '5018', name: 'Industrial Loft Building, Loft Building', classCode: 'I' },
  { id: '5012', name: 'Industrial Park', classCode: 'I' },
  { id: '6016', name: 'Labor Camps (Industrial)', classCode: 'I' },
  { id: '5011', name: 'Laboratory, Research and Development Facility, Cosmetics, Pharmaceutical', classCode: 'I' },
  { id: '5002', name: 'Light Industrial', classCode: 'I' },
  { id: '5015', name: 'Lumber & Wood Product MFG (including furniture)', classCode: 'I' },
  { id: '6010', name: 'Lumberyard, Building Materials', classCode: 'I' },
  { id: '5001', name: 'Manufacturing (light)', classCode: 'I' },
  { id: '5014', name: 'Marine Facility/Boat Repairs (small craft or sailboat)', classCode: 'I' },
  { id: '6007', name: 'Mill', classCode: 'I' },
  { id: '6003', name: 'Mining', classCode: 'I' },
  { id: '5013', name: 'Multi-Tenant Industrial Bldg', classCode: 'I' },
  { id: '5016', name: 'Paper Product MFG & related products', classCode: 'I' },
  { id: '5017', name: 'Printing & Publishing (Light Industrial)', classCode: 'I' },
  { id: '6009', name: 'Processing Plant', classCode: 'I' },
  { id: '6014', name: 'Quarries', classCode: 'I' },
  { id: '5008', name: 'Recycling plant', classCode: 'I' },
  { id: '6006', name: 'Refinery, Petroleum Products', classCode: 'I' },
  { id: '6011', name: 'Shipyard/Storage - Built or Repaired (seagoing vessels)', classCode: 'I' },
  { id: '6012', name: 'Slaughter House, Stockyard', classCode: 'I' },
  { id: '6004', name: 'Storage yard (junk; auto wrecking, salvage)', classCode: 'I' },
  { id: '5004', name: 'Storage yard, Open Storage (light equipment, material)', classCode: 'I' },
  { id: '6025', name: 'Sugar Refinery', classCode: 'I' },
  { id: '6001', name: 'Transportation', classCode: 'I' },
  // { id: '5003', name: 'Warehouse (Industrial)', classCode: 'I' },
  { id: '6013', name: 'Waste Disposal, Sewage, Treatment facility', classCode: 'I' },
  { id: '6017', name: 'Winery', classCode: 'I' },
  // { id: '3000', name: 'Commercial Office (General)', classCode: 'O' },
  { id: '3011', name: 'Common Area (commercial)', classCode: 'O' },
  { id: '3008', name: 'Condominium Offices', classCode: 'O' },
  { id: '3005', name: 'Dental Bldg', classCode: 'O' },
  { id: '3007', name: 'Financial Bldg', classCode: 'O' },
  { id: '3006', name: 'Medical Bldg', classCode: 'O' },
  // { id: '3010', name: 'Mixed Use (Commercial/Industrial)', classCode: 'O' },
  { id: '3012', name: 'Mobile Commercial Units', classCode: 'O' },
  // { id: '3003', name: 'Office Bldg (General)', classCode: 'O' },
  { id: '3004', name: 'Office Bldg (multi-story)', classCode: 'O' },
  { id: '3001', name: 'Professional Bldg (legal; insurance; real estate; etc.)', classCode: 'O' },
  { id: '3002', name: 'Professional Bldg (multi-story)', classCode: 'O' },
  { id: '3009', name: 'Skyscraper/High-rise (Commercial Offices)', classCode: 'O' },
  { id: '1105', name: 'Apartment house (100+ units)', classCode: 'R' },
  { id: '1104', name: 'Apartment house (5+ units)', classCode: 'R' },
  { id: '1112', name: 'Apartments (generic)', classCode: 'R' },
  { id: '1108', name: 'Boarding or Rooming House, Apt Hotel, Transient Lodgings', classCode: 'R' },
  { id: '1013', name: 'Bungalow (Residential)', classCode: 'R' },
  { id: '1003', name: 'Cluster home (Residential)', classCode: 'R' },
  { id: '1004', name: 'Condominium (Residential)', classCode: 'R' },
  { id: '1005', name: 'Cooperative (Residential)', classCode: 'R' },
  { id: '1113', name: 'Dormitory, Group Quarters (Residential)', classCode: 'R' },
  { id: '1101', name: 'Duplex (2 units, any combination)', classCode: 'R' },
  { id: '1111', name: 'Fraternity or Sorority House', classCode: 'R' },
  { id: '1106', name: 'Garden Apt, Court Apt (5+ units)', classCode: 'R' },
  { id: '1018', name: 'Garden Home', classCode: 'R' },
  { id: '1107', name: 'High-rise Apartments', classCode: 'R' },
  { id: '1019', name: 'Landominium', classCode: 'R' },
  { id: '1016', name: 'Manufactured, Modular, Pre-Fabricated Homes', classCode: 'R' },
  { id: '1015', name: 'Misc Residential Improvement', classCode: 'R' },
  { id: '1109', name: 'Mobile Home or Trailer Park', classCode: 'R' },
  { id: '1006', name: 'Mobile home', classCode: 'R' },
  { id: '1110', name: 'Multi-Family Dwellings (Generic, 2+)', classCode: 'R' },
  { id: '1017', name: 'Patio Home', classCode: 'R' },
  { id: '1009', name: 'Planned Unit Development (PUD Residential)', classCode: 'R' },
  { id: '1103', name: 'Quadruplex (4 units, any combination)', classCode: 'R' },
  // { id: '1000', name: 'Residential (General) (Single)', classCode: 'R' },
  { id: '1010', name: 'Residential Common Area (Condo/PUD/etc.)', classCode: 'R' },
  { id: '1114', name: 'Residential Condominium Development (Association Assessment)', classCode: 'R' },
  { id: '1100', name: 'Residential Income (General) (Multi-Family)', classCode: 'R' },
  { id: '1901', name: 'Residential Parking Garage', classCode: 'R' },
  { id: '1902', name: 'Residential Storage Space is mainly applied to storage spaces that are assessed separately from their correlated Condos', classCode: 'R' },
  { id: '1007', name: 'Row house (Residential)', classCode: 'R' },
  { id: '1008', name: 'Rural Residence (Agricultural)', classCode: 'R' },
  { id: '1012', name: 'Seasonal, Cabin, Vacation Residence', classCode: 'R' },
  // { id: '1999', name: 'Single Family Residential', classCode: 'R' },
  // { id: '1001', name: 'Single Family Residential', classCode: 'R' },
  { id: '1011', name: 'Timeshare (Residential)', classCode: 'R' },
  { id: '1002', name: 'Townhouse (Residential)', classCode: 'R' },
  { id: '1102', name: 'Triplex (3 units, any combination)', classCode: 'R' },
  { id: '1014', name: 'Zero Lot Line (Residential)', classCode: 'R' },
  { id: '6501', name: 'Airport & related', classCode: 'T' },
  // { id: '6505', name: 'Bus Terminal', classCode: 'T' },
  { id: '6509', name: 'Cable TV Station Communications', classCode: 'T' },
  { id: '6512', name: 'Commercial Auto Transportation/Storage', classCode: 'T' },
  { id: '6503', name: 'Freeways, State Hwys', classCode: 'T' },
  { id: '6510', name: 'Harbor & Marine Transportation', classCode: 'T' },
  { id: '6511', name: 'Microwave', classCode: 'T' },
  { id: '6513', name: 'Pollution Control', classCode: 'T' },
  { id: '6507', name: 'Radio or TV Station Communications', classCode: 'T' },
  { id: '6502', name: 'Railroad & related', classCode: 'T' },
  { id: '6504', name: 'Roads, Streets, Bridges', classCode: 'T' },
  { id: '6506', name: 'Telegraph, Telephone Communications', classCode: 'T' },
  // { id: '6500', name: 'Transportation & Communications (General)', classCode: 'T' },
  // { id: '6508', name: 'Truck Terminal (Motor Freight)', classCode: 'T' },
  { id: '8013', name: 'Abandoned Site, Contaminated Site', classCode: 'V' },
  { id: '8008', name: 'Agricultural-Unimproved Vacant Land', classCode: 'V' },
  { id: '8504', name: 'Centrally Assessed', classCode: 'V' },
  { id: '8002', name: 'Commercial-Vacant Land', classCode: 'V' },
  { id: '8006', name: 'Government-Vacant Land', classCode: 'V' },
  { id: '8003', name: 'Industrial-Vacant Land', classCode: 'V' },
  { id: '8005', name: 'Institutional-Vacant Land', classCode: 'V' },
  // { id: '8007', name: 'Multi-Family-Vacant Land', classCode: 'V' },
  { id: '8004', name: 'Private Preserve, Open Space-Vacant Land (Forest Land, Conservation)', classCode: 'V' },
  { id: '8010', name: 'Recreational-Vacant Land', classCode: 'V' },
  { id: '8503', name: 'Redevelopment Agency or Zone', classCode: 'V' },
  { id: '8502', name: 'Regulating Districts & Assessments; Tax Abatement', classCode: 'V' },
  // { id: '8001', name: 'Residential-Vacant Land', classCode: 'V' },
  { id: '8501', name: 'SBE - Special Assessments', classCode: 'V' },
  { id: '8500', name: 'Special Purpose', classCode: 'V' },
  { id: '8014', name: 'Under Construction', classCode: 'V' },
  { id: '8012', name: 'Unusable Land (Remnant, Steep, etc.)', classCode: 'V' },
  // { id: '8000', name: 'Vacant Land (General)', classCode: 'V' },
  { id: '8009', name: 'Waste Land, Marsh, Swamp', classCode: 'V' },
  { id: '8011', name: 'Water Area (Lakes; River; Shore)', classCode: 'V' },
];

export const PropertyTypeFamilyNew = [
  // { id: 'SFR', name: 'Single Family' , classCode: 'R' },
  // { id: 'CONDO', name: 'Condo/Townhouse' , classCode: 'R'},
  { id: 'MULTI2', name: 'Multi-Family 2-4', classCode: 'R' },
  { id: 'MULTI5', name: 'Multi-Family 5+', classCode: 'R' },
  { id: 'DUPLEX', name: 'Duplex', classCode: 'R' },
];

export const LeadListScreen = {
  id: 'LEADLIST',
  title: 'LEAD LIST',
  fields:
    { name: 'listingType', label: 'Lead Lists', options: ListingTypeOptions },
};


export const PropertyCharacteristicsScreen = {
  name: 'PROPERTY',
  title: 'Property Characteristics',
  propertyClassCode: { name: 'propertyClassCode', label: 'Property Classification(s)', options: PropertyClassOptionsList },
  landUseCode: { name: 'landUseCode', type: 'list', label: 'Property Type(s)', options: [] },
};


// liens
export const LienTypeCode = [
  { label: 'Tax Lien', value: 'TAX' },
  { label: 'HOA Lien', value: 'HOA' },
  { label: 'Mechanics Lien', value: 'MECHANIC' },
  { label: 'Utility Lien', value: 'UTILITY' },
  { label: 'Solar Lien', value: 'SOLAR' },
  { label: 'Child Support Lien', value: 'CHILD' },
  { label: 'Other', value: 'OTHER' },
  { label: 'Lien Released', value: 'LIEN_RELEASED' },
];

// MORTGAGE
const OpenMortgageOptions = [
  { label: '0', value: '0' },
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
];

export const OpenMortgageOptionsList = mapLoanTypesWithIdName(OpenMortgageOptions);

const LoanTypes = [
  { label: 'Conventional', value: 'CONVENTIONAL' },
  { label: 'FHA', value: 'FHA' },
  { label: 'VA', value: 'VA' },
  { label: 'Credit Line', value: 'CREDIT' },
  { label: 'Reverse Mortgage', value: 'REVERSE' },
  { label: 'Commercial', value: 'COMMERCIAL' },
  { label: 'Construction', value: 'CONSTRUCTION' },
  { label: 'Other', value: 'OTHER' },
  { label: 'Unknown', value: 'UNKNOWN' },
];

const FinancingTypes = [
  { label: 'Fixed Rate', value: 'FIXED' },
  { label: 'Adjustable Rate', value: 'ADJUSTABLE' },
  { label: 'Variable Rate', value: 'VARIABLE' },
  { label: 'Step Interest Rate', value: 'STEP' },
  { label: 'Other', value: 'OTHER' },
  { label: 'Unknown', value: 'UNKNOWN' },
];

const NotificationIntervals = [
  { label: 'Never', value: '' },
  { label: 'Immediately', value: 'IMMEDIATE' },
  { label: 'Daily', value: 'DAILY' },
  { label: 'Weekly', value: 'WEEKLY' },
];

export function mapLoanTypesWithIdName(datTypes) {
  return datTypes.map(type => ({
    id: type.value,
    name: type.label,
    value: type.value,
    label: type.label,
  }));
}

export const NotificationIntervalsOptions = mapLoanTypesWithIdName(NotificationIntervals);

export const LoanTypesOptions = mapLoanTypesWithIdName(LoanTypes);
export const FinancingTypesOptions = mapLoanTypesWithIdName(FinancingTypes);
export const LienTypeCodeList = mapLoanTypesWithIdName(LienTypeCode);

// OwnerInform
export const TaxExemptionOptions = [
  { id: 'CEMETERY', name: 'Cemetery', label: 'Cemetery', value: 'CEMETERY' },
  { id: 'DISABLED', name: 'Disabled', label: 'Disabled', value: 'DISABLED' },
  { id: 'HOMESTEAD', name: 'Homestead', label: 'Homestead', value: 'HOMESTEAD' },
  { id: 'HOSPITAL', name: 'Hospital', label: 'Hospital', value: 'HOSPITAL' },
  { id: 'LIBRARY', name: 'Library', label: 'Library', value: 'LIBRARY' },
  { id: 'RELIGIOUS', name: 'Religious', label: 'Religious', value: 'RELIGIOUS' },
  { id: 'SCHOOL', name: 'School', label: 'School', value: 'SCHOOL' },
  { id: 'SENIOR_CITIZEN', name: 'Senior Citizen', label: 'Senior Citizen', value: 'SENIOR_CITIZEN' },
  { id: 'UTILITIES', name: 'Utilities', label: 'Utilities', value: 'UTILITIES' },
  { id: 'VETERAN', name: 'Veteran', label: 'Veteran', value: 'VETERAN' },
  { id: 'WELFARE', name: 'Welfare', label: 'Welfare', value: 'WELFARE' },
  { id: 'WIDOW', name: 'Widow', label: 'Widow', value: 'WIDOW' },
  { id: 'NONE', name: 'No Exemption Status', label: 'No Exemption Status', value: 'NONE' },
];

export const OwnerLocationOptions = [
  { label: 'Out of State', name: 'Out of State', id: 'OUT_OF_STATE' },
  { label: 'Out of County', name: 'Out of County', id: 'OUT_OF_COUNTY' },
  { label: 'Local', name: 'Local', id: 'LOCAL' },
];

export const OwnershipOptions = [
  { label: 'Individual', name: 'Individual', id: 'INDIVIDUAL' },
  { label: 'Corporate', name: 'Corporate', id: 'CORPORATE' },
  { label: 'Mixed', name: 'Mixed', id: 'MIXED' },
  { label: 'Trust', name: 'Trust', id: 'TRUST' },
];

// mls
export const MlsListingTypeOptions = [
  { label: 'Any', value: '' },
  { label: 'For Sale', value: false },
  { label: 'For Rent', value: true },
];

export const OnMarketOption = [
  { label: 'Any', value: '' },
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];

export const MlsListingStatus = [
  { label: 'ACTIVE', name: 'Active', id: 'ACTIVE' },
  { label: 'PENDING', name: 'Pending', id: 'PENDING' },
  { label: 'CONTINGENT', name: 'Contingent', id: 'CONTINGENT' },
  { label: 'ACTIVE UNDER CONTRACT', name: 'Active Under Contract', id: 'ACTIVE_UNDER_CONTRACT' },
  { label: 'COMING SOON', name: 'Coming Soon', id: 'COMING_SOON' },
  { label: 'FAIL', name: 'Failed', id: 'FAIL' },
  { label: 'SOLD', name: 'Sold', id: 'SOLD' },
  { label: 'REMOVED', name: 'Removed', id: 'REMOVED' },
  { label: 'DELETED', name: 'Deleted', id: 'DELETED' },
  { label: 'CANCELED', name: 'Canceled', id: 'CANCELED' },
  { label: 'EXPIRED', name: 'Expired', id: 'EXPIRED' },
  { label: 'WITHDRAWN', name: 'Withdrawn', id: 'WITHDRAWN' },
  { label: 'NONE', name: 'Never Listed', id: 'NONE' },
];

// PB New options
// used for mls


const garageTypes = [
  'Attached Garage',
  'Built-in',
  'Carport',
  'Detached Garage',
  'Pole',
  'Offsite',
  'Garage',
  'Unimproved',
  'Parking Lot',
  'Mixed',
  'None',
  'Open',
  'Paved/Surfaced',
  'Ramp',
  'Parking Structure',
  'Tuckunder',
  'Underground/Basement',
  'Covered',
  'Yes - Unspecified',
];

const poolTypes = [
  'Above ground pool',
  'Pool & Spa (both)',
  'Community Pool or Spa',
  'Enclosed',
  'Heated Pool',
  'Indoor Swimming Pool',
  'Solar Heated',
  'Pool (yes)',
  'Spa or Hot Tub (only)',
  'Vinyl In-ground Pool',
];

const basementTypes = [
  'Daylight, Full',
  'Full Basement',
  'Improved Basement (Finished)',
  'Daylight, Partial',
  'No Basement',
  'Partial Basement',
  'Unfinished Basement',
  'Unspecified Basement',
];

export function mapOptionsWithString(items) {
  return items.map(item => ({
    id: item,
    name: item,
    value: item,
    label: item,
  }));
}

export const PropertyPoolTypeList = mapOptionsWithString(poolTypes);
export const PropertyGarageTypesList = mapOptionsWithString(garageTypes);
export const PropertyBasementTypesList = mapOptionsWithString(basementTypes);


export const IncludeExcludeOptions = [
  { label: 'Any', value: '' },
  { label: 'Include', value: true },
  { label: 'Exclude', value: false },
];

export const YesNoOptions = [
  { label: 'Any', value: '' },
  { label: 'Yes', value: true },
  { label: 'No', value: false },
];


export const PreForeclosureList = [
  { label: 'Any', value: '' },
  { label: 'Include', value: 'PreForeclosure' },
  { label: 'Exclude', value: 'PreForeclosureExclude' },
];

const ForeclosureStatusInclude = [
  { label: 'Notice of Default / Lis Pendens', value: 'PRE_FORECLOSURE' },
  { label: 'Auctions', value: 'AUCTION' },
  { label: 'Default Releases', value: 'RECISSION' },
  { label: 'Bank Owned', value: 'FORECLOSURE' },
  // { label: 'Exclude Foreclosures', value: 'NONE' },
];

export const ForeclosureStatusExclude = [
  // { label: 'Notice of Default / Lis Pendens', value: 'PRE_FORECLOSURE' },
  // { label: 'Auctions', value: 'AUCTION' },
  // { label: 'Default Releases', value: 'RECISSION' },
  // { label: 'Bank Owned', value: 'FORECLOSURE' },
  { label: 'Exclude Foreclosures', value: 'NONE' },
];
export const ForeclosureStatusIncludeOptions = mapLoanTypesWithIdName(ForeclosureStatusInclude);
export const ForeclosureStatusExcludeOptions = mapLoanTypesWithIdName(ForeclosureStatusExclude);


export const LienOptions = [
  { label: 'Any', value: '' },
  { label: 'Include', value: true },
  { label: 'Exclude', value: false },
];

export const BankruptcyOptions = [
  { label: 'Any', value: '' },
  { label: 'Include', value: true },
  { label: 'Exclude', value: false },
];

export const DivorceOptions = [
  { label: 'Any', value: '' },
  { label: 'Include', value: true },
  { label: 'Exclude', value: false },
];

// const LienStatusOptions = [
//   { label: 'Has Active Lien', value: 'LIEN' },
//   { label: 'Has Active Bankruptcy', value: 'BANKRUPTCY' },
//   { label: 'Has Divorce', value: 'DIVORCE' },
//   { label: 'Lien Released', value: 'LIEN_RELEASED' },
//   { label: 'Bankruptcy Dismissed', value: 'BANKRUPTCY_DISMISSED' },
// ];

export const BedroomOptions = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
];

export const BathroomOptions = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
];

export const BuildingSizeOptions = [
  { label: '500 sqft', value: '500' },
  { label: '1000 sqft', value: '1000' },
  { label: '1500 sqft', value: '1500' },
  { label: '2000 sqft', value: '2000' },
  { label: '2500 sqft', value: '2500' },
];

export const LotSizeOptions = [
  { label: '21,780 sqft (0.5 acres)', value: '21780' },
  { label: '43,560 sqft (1 acre)', value: '43560' },
  { label: '87,120 sqft (2 acres)', value: '87120' },
  { label: '130,680 sqft (3 acres)', value: '130680' },
  { label: '174,240 sqft (4 acres)', value: '174240' },
];

export const YearBuiltOptions = [
  { label: '1940', value: '1940' },
  { label: '1960', value: '1960' },
  { label: '1980', value: '1980' },
  { label: '2000', value: '2000' },
  { label: '2010', value: '2010' },
];

export const TaxDelinquentYearOptions = [
  { label: '1990', value: '1990' },
  { label: '1991', value: '1991' },
  { label: '1992', value: '1992' },
  { label: '1993', value: '1993' },
  { label: '1994', value: '1994' },
  { label: '1995', value: '1995' },
  { label: '1996', value: '1996' },
  { label: '1997', value: '1997' },
  { label: '1998', value: '1998' },
  { label: '1999', value: '1999' },
  { label: '2000', value: '2000' },
  { label: '2001', value: '2001' },
  { label: '2002', value: '2002' },
  { label: '2003', value: '2003' },
  { label: '2004', value: '2004' },
  { label: '2005', value: '2005' },
  { label: '2006', value: '2006' },
  { label: '2007', value: '2007' },
  { label: '2008', value: '2008' },
  { label: '2009', value: '2009' },
  { label: '2010', value: '2010' },
  { label: '2011', value: '2011' },
  { label: '2012', value: '2012' },
  { label: '2013', value: '2013' },
  { label: '2014', value: '2014' },
  { label: '2015', value: '2015' },
  { label: '2016', value: '2016' },
  { label: '2017', value: '2017' },
  { label: '2018', value: '2018' },
  { label: '2019', value: '2019' },
  { label: '2020', value: '2020' },
  { label: '2021', value: '2021' },
  { label: '2022', value: '2022' },
  { label: '2023', value: '2023' },
  { label: '2024', value: '2024' }
];

export const NumberUnitOptions = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
];

export const NumberStoryOptions = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
];

// export const MlsStatusDateOptions = [
//   { label: 'Any',     id: ''  , value: ''    },
//   { label: '1 week',  id: '1' , value: '1week'},
//   { label: '2 weeks', id: '2' , value: '2weeks'},
//   { label: '3 weeks', id: '3' , value: '3weeks'},
//   { label: '4 weeks', id: '4' , value: '4weeks'},
//   { label: '5 weeks', id: '5' , value: '5weeks'},
//   { label: '6 weeks', id: '6' , value: '6weeks'},
//   { label: '7 weeks', id: '7' , value: '7weeks'},
//   { label: '8 weeks', id: '8' , value: '8weeks'},
// ];

export const MlsStatusDateOptions = [
  // { label: 'Any',      id: '0',   value: '',       fromDate: null, toDate: null },
  { label: '1 week', id: '1', value: '1 week', fromDate: null, toDate: null },
  { label: '2 weeks', id: '2', value: '2 weeks', fromDate: null, toDate: null },
  { label: '3 weeks', id: '3', value: '3 weeks', fromDate: null, toDate: null },
  { label: '4 weeks', id: '4', value: '4 weeks', fromDate: null, toDate: null },
  { label: '5 weeks', id: '5', value: '5 weeks', fromDate: null, toDate: null },
  { label: '6 weeks', id: '6', value: '6 weeks', fromDate: null, toDate: null },
  { label: '7 weeks', id: '7', value: '7 weeks', fromDate: null, toDate: null },
  { label: '8 weeks', id: '8', value: '8 weeks', fromDate: null, toDate: null },
];

// Calculate fromDate and toDate based on selected option
const today = new Date();
MlsStatusDateOptions.forEach((option) => {
  if (option.value === '1 week') {
    const fromDate = new Date(today);
    const toDate = new Date(today);
    fromDate.setDate(today.getDate() - 7); // Set fromDate to 1 week ago
    option.fromDate = fromDate.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: '2-digit' });
    option.toDate = new Date().toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: '2-digit' }); // Set toDate to today
  } else if (option.value.endsWith('weeks')) {
    const weeks = parseInt(option.value); // Extract the number of weeks
    const fromDate = new Date(today);
    fromDate.setDate(today.getDate() - weeks * 7); // Subtract weeks from the current date
    option.fromDate = fromDate.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: '2-digit' });
    option.toDate = new Date().toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: '2-digit' }); // Set toDate to today
  }
});

export const DaysMarketOptions = [
  { label: '10', value: '10' },
  { label: '20', value: '20' },
  { label: '30', value: '30' },
  { label: '40', value: '40' },
  { label: '50', value: '50' },
];

export const foreclosureFactorOptions = [
  { label: 'Very Low', value: 'Very Low' },
  { label: 'Low', value: 'Low' },
  { label: 'Medium Low', value: 'Medium Low' },
  { label: 'Medium High', value: 'Medium High' },
  { label: 'High', value: 'High' },
  { label: 'Very High', value: 'Very High' },
];

export const PSScoreOptions = [
  { label: 'Disrepair', value: 'Disrepair', min: 5.6, max: 6.0 },
  { label: 'Poor', value: 'Poor', min: 4.6, max: 5.5 },
  { label: 'Average', value: 'Average', min: 3.6, max: 4.5 },
  { label: 'Good', value: 'Good', min: 2.6, max: 3.5 },
  { label: 'Excellent', value: 'Excellent', min: 1.6, max: 2.5 },
  { label: 'Luxury', value: 'Luxury', min: 1.0, max: 1.5 },
];

export const FFScoreOptions = [
  { label: 'Very Low', value: 'Very Low', min: 1, max: 10 },
  { label: 'Low', value: 'Low', min: 11, max: 30 },
  { label: 'Medium Low', value: 'Medium Low', min: 31, max: 50 },
  { label: 'Medium High', value: 'Medium High', min: 51, max: 70 },
  { label: 'High', value: 'High', min: 71, max: 90 },
  { label: 'Very High', value: 'Very High', min: 91, max: 100 }
];

export const PSScoreOptionsMin = PSScoreOptions.map(option => ({
  ...option,
  value: option.min,
}));

export const PSScoreOptionsMax = PSScoreOptions.map(option => ({
  ...option,
  value: option.max,
}));

export const FFScoreOptionsMin = FFScoreOptions.map(option => ({
  ...option,
  value: option.min,
}));

export const FFScoreOptionsMax = FFScoreOptions.map(option => ({
  ...option,
  value: option.max,
}));

export const getMatchingPCScoreValues = (searchTerm) => {
  return PSScoreOptions
    .filter(option => option.label.toLowerCase().includes(searchTerm.toLowerCase()))
    .map(option => option.min);
};

export const getMatchingFFScoreValues = (searchTerm) => {
  return FFScoreOptions
    .filter(option => option.label.toLowerCase().includes(searchTerm.toLowerCase()))
    .map(option => option.min);
};

export const getCategoryFromPCScore = (score) => {
  if (score >= 5.6 && score <= 6.0) return "Disrepair";
  if (score >= 4.6 && score <= 5.5) return "Poor";
  if (score >= 3.6 && score <= 4.5) return "Average";
  if (score >= 2.6 && score <= 3.5) return "Good";
  if (score >= 1.6 && score <= 2.5) return "Excellent";
  if (score >= 1.0 && score <= 1.5) return "Luxury";
  return null; // Return null for scores outside defined ranges
};

export const getRangeFromFFScoreCategory = (score) => {
  if (score >= 1 && score <= 10) return "Very Low";
  if (score >= 11 && score <= 30) return "Low";
  if (score >= 31 && score <= 50) return "Medium Low";
  if (score >= 51 && score <= 70) return "Medium High";
  if (score >= 71 && score <= 90) return "High";
  if (score >= 91 && score <= 100) return "Very High";
  return null;
};

export const ListingAmountOptions = [
  { label: '50,000', value: '50000' },
  { label: '100,000', value: '100000' },
  { label: '150,000', value: '150000' },
  { label: '200,000', value: '200000' },
  { label: '250,000', value: '250000' },
  { label: '300,000', value: '300000' },
  { label: '350,000', value: '350000' },
  { label: '400,000', value: '400000' },
  { label: '450,000', value: '450000' },
  { label: '500,000', value: '500000' },
  { label: '550,000', value: '550000' },
  { label: '600,000', value: '600000' },
  { label: '650,000', value: '650000' },
  { label: '700,000', value: '700000' },
  { label: '750,000', value: '750000' },
  { label: '800,000', value: '800000' },
  { label: '850,000', value: '850000' },
  { label: '900,000', value: '900000' },
  { label: '950,000', value: '950000' },
  { label: '1,000,000', value: '1000000' },
  { label: '1,250,000', value: '1250000' },
  { label: '1,500,000', value: '1500000' },
  { label: '1,750,000', value: '1750000' },
  { label: '2,000,000', value: '2000000' },
  { label: '2,250,000', value: '2250000' },
  { label: '2,500,000', value: '2500000' },
  { label: '2,750,000', value: '2750000' },
  { label: '3,000,000', value: '3000000' },
  { label: '3,250,000', value: '3250000' },
  { label: '3,500,000', value: '3500000' },
  { label: '3,750,000', value: '3750000' },
  { label: '4,000,000', value: '4000000' },
  { label: '4,250,000', value: '4250000' },
  { label: '4,500,000', value: '4500000' },
  { label: '4,750,000', value: '4750000' },
  { label: '5,000,000', value: '5000000' }
];

export const ListingAmountOptionsList = mapLoanTypesWithIdName(ListingAmountOptions);

// const ForeclosureDateOptions = [
//   { label: 'Any', value: '0' },
//   { label: 'last month', value: '1' },
//   { label: 'last 3 months', value: '3' },
//   { label: 'last 6 months', value: '6' },
//   { label: 'last 9 months', value: '9' },
//   { label: 'last 12 months', value: '12' },
// ];

export const ForeclosureDateOptions = [
  // { id: '0', value: '', label: 'Any',             fromDate: null, toDate: null },
  { id: '3', value: 'last 3 months', label: 'last 3 months', fromDate: null, toDate: null },
  { id: '6', value: 'last 6 months', label: 'last 6 months', fromDate: null, toDate: null },
  { id: '9', value: 'last 9 months', label: 'last 9 months', fromDate: null, toDate: null },
  { id: '12', value: 'last 12 months', label: 'last 12 months', fromDate: null, toDate: null },
];

// Calculate fromDate and toDate based on selected option
ForeclosureDateOptions.forEach((option) => {
  const months = parseInt(option.id); // Extract the number of months
  const fromDate = new Date();
  fromDate.setMonth(fromDate.getMonth() - months); // Subtract months from the current month
  option.fromDate = fromDate.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: '2-digit' });
  option.toDate = new Date().toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: '2-digit' }); // toDate remains today's date
});

const OpeningAmountOptions = [
  { label: '50,000', value: '50000' },
  { label: '100,000', value: '100000' },
  { label: '150,000', value: '150000' },
  { label: '200,000', value: '200000' },
  { label: '250,000', value: '250000' },
  { label: '300,000', value: '300000' },
  { label: '350,000', value: '350000' },
  { label: '400,000', value: '400000' },
  { label: '450,000', value: '450000' },
  { label: '500,000', value: '500000' },
  { label: '550,000', value: '550000' },
  { label: '600,000', value: '600000' },
  { label: '650,000', value: '650000' },
  { label: '700,000', value: '700000' },
  { label: '750,000', value: '750000' },
  { label: '800,000', value: '800000' },
  { label: '850,000', value: '850000' },
  { label: '900,000', value: '900000' },
  { label: '950,000', value: '950000' },
  { label: '1,000,000', value: '1000000' },
  { label: '1,250,000', value: '1250000' },
  { label: '1,500,000', value: '1500000' },
  { label: '1,750,000', value: '1750000' },
  { label: '2,000,000', value: '2000000' },
  { label: '2,250,000', value: '2250000' },
  { label: '2,500,000', value: '2500000' },
  { label: '2,750,000', value: '2750000' },
  { label: '3,000,000', value: '3000000' },
  { label: '3,250,000', value: '3250000' },
  { label: '3,500,000', value: '3500000' },
  { label: '3,750,000', value: '3750000' },
  { label: '4,000,000', value: '4000000' },
  { label: '4,250,000', value: '4250000' },
  { label: '4,500,000', value: '4500000' },
  { label: '4,750,000', value: '4750000' },
  { label: '5,000,000', value: '5000000' }
];

const DefaultAmountOptions = [
  { label: '50,000', value: '50000' },
  { label: '100,000', value: '100000' },
  { label: '150,000', value: '150000' },
  { label: '200,000', value: '200000' },
  { label: '250,000', value: '250000' },
  { label: '300,000', value: '300000' },
  { label: '350,000', value: '350000' },
  { label: '400,000', value: '400000' },
  { label: '450,000', value: '450000' },
  { label: '500,000', value: '500000' },
  { label: '550,000', value: '550000' },
  { label: '600,000', value: '600000' },
  { label: '650,000', value: '650000' },
  { label: '700,000', value: '700000' },
  { label: '750,000', value: '750000' },
  { label: '800,000', value: '800000' },
  { label: '850,000', value: '850000' },
  { label: '900,000', value: '900000' },
  { label: '950,000', value: '950000' },
  { label: '1,000,000', value: '1000000' },
  { label: '1,250,000', value: '1250000' },
  { label: '1,500,000', value: '1500000' },
  { label: '1,750,000', value: '1750000' },
  { label: '2,000,000', value: '2000000' },
  { label: '2,250,000', value: '2250000' },
  { label: '2,500,000', value: '2500000' },
  { label: '2,750,000', value: '2750000' },
  { label: '3,000,000', value: '3000000' },
  { label: '3,250,000', value: '3250000' },
  { label: '3,500,000', value: '3500000' },
  { label: '3,750,000', value: '3750000' },
  { label: '4,000,000', value: '4000000' },
  { label: '4,250,000', value: '4250000' },
  { label: '4,500,000', value: '4500000' },
  { label: '4,750,000', value: '4750000' },
  { label: '5,000,000', value: '5000000' }
];

export const DefaultAmountOptionsList = mapLoanTypesWithIdName(DefaultAmountOptions);
export const OpeningAmountOptionsList = mapLoanTypesWithIdName(OpeningAmountOptions);


export const YearOwnershipOptions = [
  { label: '5', value: '5' },
  { label: '10', value: '10' },
  { label: '15', value: '15' },
  { label: '20', value: '20' },
  { label: '25', value: '25' },
];

export const LastSalePriceOptions = [
  { label: '50,000', value: '50000' },
  { label: '100,000', value: '100000' },
  { label: '150,000', value: '150000' },
  { label: '200,000', value: '200000' },
  { label: '250,000', value: '250000' },
  { label: '300,000', value: '300000' },
  { label: '350,000', value: '350000' },
  { label: '400,000', value: '400000' },
  { label: '450,000', value: '450000' },
  { label: '500,000', value: '500000' },
  { label: '550,000', value: '550000' },
  { label: '600,000', value: '600000' },
  { label: '650,000', value: '650000' },
  { label: '700,000', value: '700000' },
  { label: '750,000', value: '750000' },
  { label: '800,000', value: '800000' },
  { label: '850,000', value: '850000' },
  { label: '900,000', value: '900000' },
  { label: '950,000', value: '950000' },
  { label: '1,000,000', value: '1000000' },
  { label: '1,250,000', value: '1250000' },
  { label: '1,500,000', value: '1500000' },
  { label: '1,750,000', value: '1750000' },
  { label: '2,000,000', value: '2000000' },
  { label: '2,250,000', value: '2250000' },
  { label: '2,500,000', value: '2500000' },
  { label: '2,750,000', value: '2750000' },
  { label: '3,000,000', value: '3000000' },
  { label: '3,250,000', value: '3250000' },
  { label: '3,500,000', value: '3500000' },
  { label: '3,750,000', value: '3750000' },
  { label: '4,000,000', value: '4000000' },
  { label: '4,250,000', value: '4250000' },
  { label: '4,500,000', value: '4500000' },
  { label: '4,750,000', value: '4750000' },
  { label: '5,000,000', value: '5000000' }
];

export const PropertyOwnedOptions = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
];

// const LastSaleDateOptions = [
//   { label: 'Any', value: '0' },
//   { label: 'last year', value: '1' },
//   { label: 'last 2 years', value: '2' },
//   { label: 'last 5 years', value: '5' },
//   { label: 'last 10 years', value: '10' },
//   { label: 'last 15 years', value: '15' },
// ];


export const LastSaleDateOptions = [
  // { label: 'Any',           id: '0',   value: '',       fromDate: null, toDate: null },
  { label: 'last year', id: '1', value: '1 year', fromDate: null, toDate: null },
  { label: 'last 2 years', id: '2', value: '2 years', fromDate: null, toDate: null },
  { label: 'last 5 years', id: '5', value: '5 years', fromDate: null, toDate: null },
  { label: 'last 10 years', id: '10', value: '10 years', fromDate: null, toDate: null },
  { label: 'last 15 years', id: '15', value: '15 years', fromDate: null, toDate: null },
];

// Calculate fromDate and toDate based on selected option
// const today = new Date();
LastSaleDateOptions.forEach((option) => {
  const years = parseInt(option.id);
  const fromDate = new Date(today);
  fromDate.setFullYear(today.getFullYear() - years); // Subtract years from the current year
  option.fromDate = fromDate.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: '2-digit' });
  option.toDate = new Date().toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: '2-digit' }); // toDate remains today's date
});

// const LBDRecordDateOptions = [
//   { label: 'Any', value: '0' },
//   { label: 'last 3 months', value: '3' },
//   { label: 'last 6 months', value: '6' },
//   { label: 'last 9 months', value: '9' },
//   { label: 'last 12 months', value: '12' },
// ];

// export const BankruptcyChapter = [
//   { value: '7', label: '7' },
//   { value: '9', label: '9' },
//   { value: '11', label: '11' },
//   { value: '12', label: '12' },
//   { value: '13', label: '13' },
//   { value: '15', label: '15' },
// ];

// export const BankruptcyChapterOptions = mapLoanTypesWithIdName(BankruptcyChapter)

export const BankruptcyChapterOptions = [
  { id: 'CH7_AC', name: 'Chapter 7 (Active)', value: '7', label: 'Chapter 7 (Active)' },
  { id: 'CH7_IN', name: 'Chapter 7 (Dismissed)', value: '7', label: 'Chapter 7 (Dismissed)' },
  { id: 'CH9_AC', name: 'Chapter 9 (Active)', value: '9', label: 'Chapter 9 (Active)' },
  { id: 'CH9_IN', name: 'Chapter 9 (Dismissed)', value: '9', label: 'Chapter 9 (Dismissed)' },
  { id: 'CH11_AC', name: 'Chapter 11 (Active)', value: '11', label: 'Chapter 11 (Active)' },
  { id: 'CH11_IN', name: 'Chapter 11 (Dismissed)', value: '11', label: 'Chapter 11 (Dismissed)' },
  { id: 'CH12_AC', name: 'Chapter 12 (Active)', value: '12', label: 'Chapter 12 (Active)' },
  { id: 'CH12_IN', name: 'Chapter 12 (Dismissed)', value: '12', label: 'Chapter 12 (Dismissed)' },
  { id: 'CH13_AC', name: 'Chapter 13 (Active)', value: '13', label: 'Chapter 13 (Active)' },
  { id: 'CH13_IN', name: 'Chapter 13 (Dismissed)', value: '13', label: 'Chapter 13 (Dismissed)' },
  { id: 'CH15_AC', name: 'Chapter 15 (Active)', value: '15', label: 'Chapter 15 (Active)' },
  { id: 'CH15_IN', name: 'Chapter 15 (Dismissed)', value: '15', label: 'Chapter 15 (Dismissed)' },
];

export const LBDRecordDateOptions = [
  // { id: '0', value: '', label: 'Any',             fromDate: null, toDate: null },
  { id: '3', value: 'last 3 months', label: 'last 3 months', fromDate: null, toDate: null },
  { id: '6', value: 'last 6 months', label: 'last 6 months', fromDate: null, toDate: null },
  { id: '9', value: 'last 9 months', label: 'last 9 months', fromDate: null, toDate: null },
  { id: '12', value: 'last 12 months', label: 'last 12 months', fromDate: null, toDate: null },
];

LBDRecordDateOptions.forEach((option) => {
  const months = parseInt(option.id); // Extract the number of months
  const fromDate = new Date(today);
  fromDate.setMonth(today.getMonth() - months); // Subtract months from the current month
  option.fromDate = fromDate.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: '2-digit' });
  option.toDate = new Date().toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: '2-digit' }); // toDate remains today's date
});

export const LienAmountOptions = [
  { label: '5,000', value: '5000' },
  { label: '10,000', value: '10000' },
  { label: '15,000', value: '15000' },
  { label: '20,000', value: '20000' },
];

export const EstimatedValueMaxLength = 10;

export const EstimatedValueOptions = [
  { label: '50,000', value: '50000' },
  { label: '100,000', value: '100000' },
  { label: '150,000', value: '150000' },
  { label: '200,000', value: '200000' },
  { label: '250,000', value: '250000' },
  { label: '300,000', value: '300000' },
  { label: '350,000', value: '350000' },
  { label: '400,000', value: '400000' },
  { label: '450,000', value: '450000' },
  { label: '500,000', value: '500000' },
  { label: '550,000', value: '550000' },
  { label: '600,000', value: '600000' },
  { label: '650,000', value: '650000' },
  { label: '700,000', value: '700000' },
  { label: '750,000', value: '750000' },
  { label: '800,000', value: '800000' },
  { label: '850,000', value: '850000' },
  { label: '900,000', value: '900000' },
  { label: '950,000', value: '950000' },
  { label: '1,000,000', value: '1000000' },
  { label: '1,250,000', value: '1250000' },
  { label: '1,500,000', value: '1500000' },
  { label: '1,750,000', value: '1750000' },
  { label: '2,000,000', value: '2000000' },
  { label: '2,250,000', value: '2250000' },
  { label: '2,500,000', value: '2500000' },
  { label: '2,750,000', value: '2750000' },
  { label: '3,000,000', value: '3000000' },
  { label: '3,250,000', value: '3250000' },
  { label: '3,500,000', value: '3500000' },
  { label: '3,750,000', value: '3750000' },
  { label: '4,000,000', value: '4000000' },
  { label: '4,250,000', value: '4250000' },
  { label: '4,500,000', value: '4500000' },
  { label: '4,750,000', value: '4750000' },
  { label: '5,000,000', value: '5000000' }

];

export const WholesaleValueOptions = [
  { label: '100,000', value: '100000' },
  { label: '200,000', value: '200000' },
  { label: '400,000', value: '400000' },
  { label: '600,000', value: '600000' },
  { label: '800,000', value: '800000' },
];

export const AssessedLandOptions = [
  { label: '10,000', value: '10000' },
  { label: '50,000', value: '50000' },
  { label: '100,000', value: '100000' },
  { label: '200,000', value: '200000' },
  { label: '500,000', value: '500000' },
];

export const PercentMinMaxOptions = [
  { name: '10', value: '10', label: '10%', },
  { name: '20', value: '20', label: '20%', },
  { name: '30', value: '30', label: '30%', },
  { name: '40', value: '40', label: '40%', },
  { name: '50', value: '50', label: '50%', },
  { name: '60', value: '60', label: '60%', },
  { name: '70', value: '70', label: '70%', },
  { name: '80', value: '80', label: '80%', },
  { name: '90', value: '90', label: '90%', },
  { name: '100', value: '100', label: '100%' },
];

export const GrowthValueListOptions = [
  { name: '1 month', value: '1 month', label: '1 month', min: 20, max: 20 },
  { name: '6 months', value: '6 months', label: '6 months', min: 40, max: 40 },
  { name: '1 year', value: '1 year', label: '1 year', min: 60, max: 60 },
  { name: '3 years', value: '3 years', label: '3 years', min: 80, max: 80 },
  { name: '5 years', value: '5 years', label: '5 years', min: 100, max: 100 },
];


export function mapLoanTypesWithIdNameMinMax(datTypes) {
  return datTypes.map(type => ({
    id: type.value,
    name: type.label,
    value: type.value,
    label: type.label,
    min: type.min,
    max: type.max,
  }));
}

// export const GrowthValueOptionsList = mapLoanTypesWithIdNameMinMax(GrowthValueOptions)


// export const GrowthValueOptions = [
//   { label: '20', value: '20' },
//   { label: '40', value: '40' },
//   { label: '60', value: '60' },
//   { label: '80', value: '80' },
//   { label: '100', value: '100' },
// ];

export const GrowthOverOptions = [
  { label: '1 month', value: '1' },
  { label: '6 months', value: '6' },
  { label: '1 year', value: '12' },
  { label: '3 years', value: '36' },
  { label: '5 years', value: '60' },
];

export const RentalIncomeOptions = [
  { label: '500', value: '500' },
  { label: '1,000', value: '1000' },
  { label: '2,000', value: '2000' },
  { label: '3,000', value: '3000' },
  { label: '4,000', value: '4000' },
];

export const EquityCurrencyOptions = [
  { label: '0', value: '0' },
  { label: '25,000', value: '25000' },
  { label: '50,000', value: '50000' },
  { label: '100,000', value: '100000' },
  { label: '150,000', value: '150000' },
];

export const EquityPercentOptions = [
  { label: '0%', value: '0' },
  { label: '20%', value: '20' },
  { label: '40%', value: '40' },
  { label: '60%', value: '60' },
  { label: '80%', value: '80' },
  { label: '100%', value: '100' },
];

export const AssessedValueOptions = [
  { label: '50,000', value: '50000' },
  { label: '100,000', value: '100000' },
  { label: '200,000', value: '200000' },
  { label: '300,000', value: '300000' },
  { label: '400,000', value: '400000' },
];

export const ImprovementTaxOptions = [
  { label: '20%', value: '20' },
  { label: '40%', value: '40' },
  { label: '60%', value: '60' },
  { label: '80%', value: '80' },
  { label: '100%', value: '100' },
];

const OpenMortgageNumOptions = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
];

const RemainBalanceOptions = [
  { label: '50,000', value: '50000' },
  { label: '100,000', value: '100000' },
  { label: '200,000', value: '200000' },
  { label: '300,000', value: '300000' },
  { label: '400,000', value: '400000' },
];

// const MortgageDateOptions = [
//   { label: 'Any', value: '0' },
//   { label: 'last 6 months', value: '6' },
//   { label: 'last year', value: '12' },
//   { label: 'last 5 years', value: '60' },
//   { label: 'last 10 years', value: '120' },
//   { label: 'last 15 years', value: '180' },
//   { label: 'last 20 years', value: '240' },
//   { label: 'last 25 years', value: '300' },
// ];

export const MortgageDateOptions = [
  // { label: 'Any',           id: '0',    value: '',           fromDate: null, toDate: null },
  { label: 'last 6 months', id: '6', value: '6 months', fromDate: null, toDate: null },
  { label: 'last year', id: '12', value: '1 year', fromDate: null, toDate: null },
  { label: 'last 5 years', id: '60', value: '5 years', fromDate: null, toDate: null },
  { label: 'last 10 years', id: '120', value: '10 years', fromDate: null, toDate: null },
  { label: 'last 15 years', id: '180', value: '15 years', fromDate: null, toDate: null },
  { label: 'last 20 years', id: '240', value: '20 years', fromDate: null, toDate: null },
  { label: 'last 25 years', id: '300', value: '25 years', fromDate: null, toDate: null },
];

// Calculate fromDate and toDate based on selected option
// const today = new Date();
MortgageDateOptions.forEach((option) => {
  const years = parseInt(option.id); // Extract the number of years
  const fromDate = new Date(today);
  fromDate.setFullYear(today.getFullYear() - years); // Subtract years from the current year
  option.fromDate = fromDate.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: '2-digit' });
  option.toDate = new Date().toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: '2-digit' }); // toDate remains today's date
});

export const MonthlyPaymentMaxLength = 10;

export const MonthlyPaymentOptions = Array(21).fill(0).map((_, index) => ({
  label: (index * 500).toLocaleString(),
  value: `${index * 500}`
}));

export const InterestRateOptions = [
  { label: '1%', value: '1' },
  { label: '2%', value: '2' },
  { label: '3%', value: '3' },
  { label: '4%', value: '4' },
  { label: '5%', value: '5' },
  { label: '6%', value: '6' },
  { label: '7%', value: '7' },
  { label: '8%', value: '8' },
  { label: '9%', value: '9' },
  { label: '10%', value: '10' },
  { label: '11%', value: '11' },
  { label: '12%', value: '12' },
  { label: '13%', value: '13' },
  { label: '14%', value: '14' },
  { label: '15%', value: '15' },
];

export const FistLoanCurrencyOptions = [
  { label: '10,000', value: '10000' },
  { label: '25,000', value: '25000' },
  { label: '50,000', value: '50000' },
  { label: '100,000', value: '100000' },
  { label: '150,000', value: '150000' },
];

export const fieldTagsMap = {

  // Property Details
  'Property Classification(s)': ['property classifications', '100+', '5+', 'abandoned', 'administration', 'administrative', 'agricultural', 'airport', 'amusement', 'apartment', 'apartment', 'appliance', 'apt', 'arcades', 'arenas', 'art', 'assembly', 'asylum', 'auditoriums', 'auto', 'bakery', 'bar', 'barren', 'beach', 'bed', 'billiard', 'boarding', 'boat', 'bottling', 'bowling', 'breakfast', 'brewery', 'bridges', 'bungalow', 'bus terminal', 'cabin', 'cable tv', 'campground', 'camps', 'cannery', 'cars', 'carwash', 'casino', 'cemetary', 'centrally assessed', 'charitable', 'charity', 'chemical', 'children', 'church', 'city', 'classifications', 'clinic', 'clubs', 'cluster', 'cocktail', 'cold storage', 'college', 'commercial', 'communications', 'community', 'condo', 'condominium', 'construction', 'contaminated', 'contracting', 'contractor', 'convalescent', 'convenience store', 'convention', 'cooperative', 'correctional', 'country club', 'county', 'court', 'crematorium', 'crops', 'cultural', 'dairy', 'dance', 'daycare', 'dental', 'department', 'desert', 'development', 'diner', 'discount', 'distillery', 'district', 'dormitory', 'drive-in', 'drive-thru', 'drug store', 'dry cleaner', 'dump', 'duplex', 'dwelling', 'emergency', 'enterprise', 'entertainment', 'exempt', 'factory', 'fairgrounds', 'farm', 'fast food', 'fastfood', 'federal', 'feedlots', 'financial', 'fire', 'florist', 'forest', 'foundry', 'franchise', 'fraternity', 'freeway', 'fuel', 'funeral', 'game', 'garage', 'garden', 'gas', 'gasoline', 'go-carts', 'golf', 'golf course', 'government', 'governmental', 'grain', 'grazing', 'greenhouse', 'grocery', 'group', 'grove', 'gym', 'handicap', 'harbor', 'health', 'healthcare', 'heavy', 'high-rise', 'highway', 'historical', 'horse', 'horticulture', 'hospital', 'hotel', 'ice', 'income', 'industrial', 'insane', 'institution', 'institutional', 'insurance', 'investors', 'irrigation', 'jail', 'junk', 'kennel', 'labor', 'laboratory', 'land', 'landominium', 'laundromat', 'laundry', 'legal', 'library', 'light', 'liquor', 'livestock', 'lodging', 'loft', 'lounge', 'low income', 'lumber', 'lumberyard', 'mall', 'manufactured', 'manufacturing', 'marina', 'marsh', 'meadow', 'medical', 'microwave', 'military', 'mill', 'mini-warehouse', 'miniature', 'mining', 'miniwarehouse', 'misc', 'mixed use', 'mobile', 'modular', 'mortuary', 'motel', 'motor freight', 'mountain', 'multi-family', 'multi-tenant', 'municipal', 'municipality', 'museums', 'native', 'native american', 'natural resources', 'neighborhood', 'nightclub', 'nursery', 'nursing', 'office', 'open space', 'orchard', 'organization', 'orphanage', 'outdoor', 'packing', 'paper', 'park', 'parking', 'parlor', 'parochial', 'pasture', 'patio', 'personal', 'pet', 'petroleum', 'pharmacy', 'photo', 'picnic', 'piers', 'plant', 'playground', 'plaza', 'police', 'pollution', 'post office', 'poultry', 'pre fabricate', 'pre school', 'pre-fabricate', 'pre-school', 'prefabricate', 'preschool', 'printer', 'printing', 'prison', 'private', 'private preserve', 'professional', 'property', 'public', 'publishing', 'PUD', 'quadruplex', 'quarries', 'quarry', 'quarters', 'race', 'racquet', 'radio station', 'railroad', 'ranch', 'range', 'real estate', 'realtor', 'recreation', 'recreational', 'recycling', 'redevelopment', 'refinery', 'religious', 'rentals', 'repair', 'reservoir', 'residence', 'residential', 'resort', 'restaurant', 'retail', 'retired', 'riding', 'roller', 'rooming', 'row house', 'rural', 'rv', 'sales', 'salvage', 'sbe', 'school', 'seasonal', 'service', 'services', 'sewage', 'shipyard', 'shooting', 'shopping', 'shore', 'single family', 'skating', 'skyscraper', 'slaughter house', 'social', 'social services', 'sorority', 'spa', 'special assessments', 'special purpose', 'stadium', 'stadiums', 'state', 'station', 'stockyard', 'storage', 'sugar', 'supermarket', 'supplies', 'supply', 'swamp', 'swim', 'swimming', 'take out', 'take-out', 'takeout', 'target', 'tavern', 'telegraph', 'telephone', 'tennis', 'theater', 'timberland', 'timeshare', 'tourist', 'townhouse', 'trail', 'trailer', 'trailer park', 'trails', 'transient', 'transportation', 'treatment', 'trees', 'triplex', 'truck', 'tv station', 'types', 'under construction', 'unimproved', 'unit', 'units', 'university', 'unusable land', 'usps', 'utility', 'vacant land', 'vacation', 'vehicle', 'veterinary', 'village', 'vineyard', 'warehouse', 'wash', 'waste', 'waste land', 'water', 'water slide', 'water supply', 'waterslide', 'waterslides', 'welfare', 'well', 'wharf', 'wholesale', 'wildlife', 'winery', 'wood', 'worship', 'yacht', 'zero lot line', 'zoo'],
  Bedrooms: ['room', 'bedroom', 'sleep'],
  Bathrooms: ['shower', 'toilet', 'room', 'bathroom', 'plumbing'],
  'Building Size (SqFt)': ['size', 'sqft', 'area', 'dimensions', 'building', 'home', 'floors', 'building size'],
  'Lot Size (SqFt)': ['size', 'sqft', 'area', 'dimensions', 'land', 'parcel', 'lot size'],
  'Year Built': ['age', 'built', 'time', 'year built'],
  'Number of Units': ['apartment', 'multi-family', 'units', 'complex', 'family', 'number of units'],
  'Number of Stories': ['building', 'second', 'stories', 'tall', 'floors', 'number of stories'],
  'School District': ['school', 'district', 'kid', 'child', 'family', 'school district'],
  'Association (HOA/COA)': ['hoa', 'coa', 'association', 'monthly', 'payment', 'fees'],
  Pool: ['swimming', 'pool', 'water'],
  'Pool Type': ['swimming', 'pool', 'water'],
  Garage: ['garage', 'storage', 'car', 'cars', 'truck', 'van', 'adu'],
  'Garage Type': ['garage', 'storage', 'car', 'cars', 'truck', 'van', 'adu'],
  Basement: ['basement', 'storage', 'room', 'adu'],
  'Basement Type': ['basement', 'storage', 'room', 'adu'],
  Attic: ['storage', 'room', 'adu', 'attic'],

  // PSI
  'Overall Property Condition': ['overall property condition', 'property condition', 'condition', 'property'],
  'Bathroom Condition': ['bathroom condition', 'bathrooms', 'condition'],
  'Kitchen Condition': ['kitchen condition', 'kitchen', 'condition'],
  'Interior Condition': ['interior condition', 'interior', 'condition'],
  'Exterior Condition': ['exterior condition', 'exterior', 'condition'],
  'Foreclosure Factor': ['foreclosure factor', 'factor', 'foreclosure'],

  // MLS
  'On Market': ['mls', 'listed', 'listings', 'sale', 'for sale', 'agent', 'realtor', 'active', 'pending', 'contingent', 'on market'],
  'Listing Type': ['mls', 'for sale', 'for rent', 'sale', 'rent', 'listing type'],
  'MLS Status': ['mls', 'active', 'agent', 'contingent', 'failed', 'listed', 'listings', 'never listed', 'pending', 'realtor', 'removed', 'sold', 'mls status'],
  'MLS Status Date': ['mls', 'date', 'status', 'time', 'mls status date'],
  'Days On Market': ['mls', 'dom', 'days on market', 'time'],
  'MLS Listing Amount': ['mls', 'amount', 'money', 'listing', 'price', 'cost', 'listing amount'],
  'Listed Below Market Price': ['mls', 'below market value', 'price', 'cost', 'under', 'value', 'listed below market price'],
  'MLS Keyword(s)': ['mls', 'agent', 'realtor', 'description', 'keyword search'],

  // Pre-Foreclosure
  'Pre-Foreclosure': ['pre-foreclosure', 'distressed', 'auction', 'lis pendens', 'default', 'notice', 'trustee\'s sale', 'sheriff\'s sale', 'trustee'],
  'Recording Date': ['recording date', 'pre-foreclosure', 'date', 'recording', 'auction', 'lis pendens', 'default', 'notice', 'trustee\'s sale', 'trustee', 'time', 'distressed', 'sherrif\'s sale'],
  'Auction Date': ['auction date', 'pre-foreclosure', 'auction', 'date', 'time', 'distressed', 'sheriff\'s sale', 'trustee\'s sale', 'trustee'],
  'Pre-Foreclosure Release Date': ['pre-foreclosure release date', 'pre-foreclosure', 'distressed', 'auction', 'lis pendens', 'default', 'notice', 'trustee\'s sale', 'trustee', 'date time', 'release', 'cancelled', 'canceled', 'sheriff\'s sale'],
  'Opening Bid Amount': ['pre-foreclosure', 'money', 'distressed', 'auction', 'sheriff\'s sale', 'trustee\'s sale', 'trustee', 'opening bid amount'],
  'Default Amount': ['pre-foreclosure', 'money', 'default', 'unpaid', 'default amount'],

  // Owner Information & Occupancy
  'Owner Occupied': ['ownership', 'owner', 'landlord', 'occupied', 'non-owner'],
  Vacant: ['empty', 'vacant', 'usps', 'vacation', 'home'],
  'Years of Ownership': ['time', 'ownership', 'length of time', 'years of ownership'],
  'Owner Type': ['owner', 'individual', 'corporate', 'mixed', 'trust'],
  'Absentee Owner Location': ['landlord', 'local', 'out of state', 'out of county', 'state', 'county', 'non-owner occupied', 'non-owner', 'nonowner', 'absentee owner location'],
  'Last Sale Price': ['last sale price', 'price', 'money', 'sale', 'prior sale', 'transfer'],
  'Number of Properties Owned': ['linked properties', 'linked', 'properties', 'multiple', 'number of properties owned'],
  'MLS Status Date': ['sale', 'date', 'prior', 'transfer', 'last sale date'],
  'Include Unknown Sales Dates': ['unknown', 'sale', 'date', 'prior', 'transfer', 'include unknown sales dates'],
  'Include Unknown Equity': ['unknown', 'include unknown equity'],
  'Pre-Probate (Deceased Owners)': ['transfer', 'probate', 'pre-probate', 'preprobate', 'pre probate', 'funeral', 'cemetary', 'deceased', 'owner'],
  'Intra-Family Transfer': ['intra-family transfer', 'transfer', 'family', 'exchange', 'no sale', 'intra', 'intra-family', 'intra family', 'intrafamily'],
  'Tax Exemption Status': ['tax exemption status', 'tax', 'exemption', 'cemetary', 'disabled', 'homestead', 'hospital', 'library', 'religious', 'school', 'senior', 'utilities', 'veteran', 'welfare', 'widow', 'no exemption'],

  // Lien, Bankruptcy, & Divorce
  'Liens Type': ['lien types', 'lien', 'tax', 'hoa', 'mechanics', 'utility', 'solar', 'child support', 'involuntary', 'voluntary', 'federal', 'state', 'county', 'city', 'released', 'date', 'recording', 'recorded', 'time', 'hoa', 'amount', 'money'],
  'Lien Recording Date': ['lien', 'tax', 'hoa', 'mechanics', 'utility', 'solar', 'child support', 'involuntary', 'voluntary', 'federal', 'state', 'county', 'city', 'released', 'date', 'recording', 'recorded', 'time', 'hoa', 'amount', 'money', 'lien recording date'],
  'Lien Amount': ['lien amount', 'lien', 'tax', 'hoa', 'mechanics', 'utility', 'solar', 'child support', 'involuntary', 'voluntary', 'federal', 'state', 'county', 'city', 'released', 'date', 'recording', 'recorded', 'time', 'hoa', 'amount', 'money'],
  'Bankruptcy Type': ['bankruptcy type', 'bankruptcy', 'chapter 7', 'chapter 13', 'active', 'dismissed', 'liquidation', 'date', 'recording', 'recorded', 'time'],
  'Bankruptcy Recording Date': ['bankruptcy recording date', 'bankruptcy', 'chapter 7', 'chapter 13', 'active', 'dismissed', 'liquidation', 'date', 'recording', 'recorded', 'time'],
  'Divorce Filing Date': ['divorce recording date', 'divorce', 'recording', 'recorded', 'date', 'separated', 'court'],
  'Tax Delinquent Year': ['tax delinquent year', 'tax', 'delinquent', 'property taxes', 'property', 'unpaid', 'taxes', 'federal', 'delinquency'],

  'Number of Open Mortgages': ['number of open mortgages', 'mortgage', 'loan', 'amount', 'conventional', 'fha', 'va', 'credit line', 'reverse mortgage', 'commercial', 'construction', 'debt', 'loan position'],
  'Open Mortgage Remaining Balance': ['open mortgage remaining balance', 'conventional', 'fha', 'va', 'credit line', 'reverse mortgage', 'commercial', 'construction', 'equity', 'mortgage', 'loan', 'amount', 'debt'],
  'Mortgage Recording Date': ['mortgage recording date', 'conventional', 'fha', 'va', 'credit line', 'reverse mortgage', 'commercial', 'construction', 'origination', 'loan', 'debt', 'date', 'mortgage'],
  'Loan Types': ['loan types', 'conventional', 'fha', 'va', 'credit line', 'reverse mortgage', 'commercial', 'construction', 'loan', 'debt', 'mortgage'],
  'Total Monthly Payments': ['total monthly payments', 'conventional', 'fha', 'va', 'credit line', 'reverse mortgage', 'commercial', 'construction', 'payment', 'mortgage', 'debt', 'loan', 'loan term', 'term'],
  'Interest Rate % (Est.)': ['interest rate % (Est)', 'interest', 'percentage', 'freddie mac', 'mortgage', 'debt', 'loan', 'fixed', 'adjustable', 'variable', 'step interest'],
  'Interest Rate Types': ['interest rate types', 'interest', 'freddie mac', 'mortgage', 'debt', 'loan', 'fixed', 'adjustable', 'variable', 'step interest'],
  '1st Loan to Current Value (1LTV) %': ['1st loan to current value (1LTV) %', 'mortgage', 'loan', 'debt', 'value', 'estimated value', 'ratio', 'percentage'],
  '1st Loan to Current Value (1LTV) Equity $': ['1st loan to current value (1LTV) $', 'mortgage', 'loan', 'debt', 'value', 'estimated value', 'ratio'],
  'Cash Buyer': ['cash', 'money', 'investors', 'buyer', 'cash buyers'],
  'Free & Clear': ['no debt', 'no mortgage', 'paid off', 'clear', 'debt free', 'free & clear'],
  'Seller Carry Back': ['carryback', 'seller financing', 'finance', 'owner financing', 'purchase-money', 'mortgage', 'seller carry back'],

  // Value & Equity
  'Estimated Value': ['value', 'price', 'amount', 'money', 'comp', 'comps', 'estimated value'],
  'Assessed Land Value': ['land', 'value', 'money', 'county', 'assessed', 'assessed land value'],
  'Growth %': ['analytics', 'increase', 'decrease', 'percentage', 'value', 'time', 'growth %'],
  'Estimated Rental Income': ['rental', 'income', 'cashflow', 'cash flow', 'estimate', 'estimated rental income'],
  'Gross Yield %': ['rental', 'revenue', 'before taxes', 'taxes', 'expenses', 'landlord', 'gross yield %'],
  'Estimated Equity $ Amount': ['estimated equity $ amount', 'equity', 'amount', 'money', 'estimated', 'high equity', 'medium equity', 'low equity', 'negative equity', 'under water', 'upside down'],
  'Estimated Equity %': ['estimated equity %', 'equity', 'percentage', 'money', 'estimated', 'high equity', 'medium equity', 'low equity', 'negative equity', 'under water', 'upside down', 'amount', 'low', 'medium', 'high'],
  'Loan to Value (LTV) %': ['loan to value (LTV) %', 'mortgage', 'loan', 'percentage', 'equity', 'low', 'high', 'medium'],
  'Assessed Total Value': ['assessed total value', 'assessed value', 'county', 'value', 'amount'],
  'Assessed Improvement Value': ['assessed improvement value', 'improvement', 'assessed', 'value', 'county', 'amount', 'renovate'],
  'Improvement to Tax Value %': ['improvement to tax value %', 'tax', 'improvement', 'value', 'percentage', 'renovate'],

  // Mortgage
  'Number of Open Mortgages': ['number of open mortgages', 'mortgage', 'loan', 'amount', 'conventional', 'fha', 'va', 'credit line', 'reverse mortgage', 'commercial', 'construction', 'debt', 'loan position'],
  'Open Mortgage Remaining Balance': ['open mortgage remaining balance', 'conventional', 'fha', 'va', 'credit line', 'reverse mortgage', 'commercial', 'construction', 'equity', 'mortgage', 'loan', 'amount', 'debt'],
  'Mortgage Recording Date': ['mortgage recording date', 'conventional', 'fha', 'va', 'credit line', 'reverse mortgage', 'commercial', 'construction', 'origination', 'loan', 'debt', 'date','mortgage'],
  'Loan Types': ['loan types', 'conventional', 'fha', 'va', 'credit line', 'reverse mortgage', 'commercial', 'construction', 'loan', 'debt', 'mortgage'],
  'Total Monthly Payments': ['total monthly payments', 'conventional', 'fha', 'va', 'credit line', 'reverse mortgage', 'commercial', 'construction', 'payment', 'mortgage', 'debt', 'loan', 'loan term', 'term'],
  'Interest Rate % (Est.)': ['interest rate % (Est)', 'interest', 'percentage', 'freddie mac', 'mortgage', 'debt', 'loan', 'fixed', 'adjustable', 'variable', 'step interest'],
  'Interest Rate Types': ['interest rate types', 'interest', 'freddie mac', 'mortgage', 'debt', 'loan', 'fixed', 'adjustable', 'variable', 'step interest'],
  '1st Loan to Current Value (1LTV) %': ['1st loan to current value (1LTV) %', 'mortgage', 'loan', 'debt', 'value', 'estimated value', 'ratio', 'percentage'],
  '1st Loan to Current Value (1LTV) Equity $': ['1st loan to current value (1LTV) $', 'mortgage', 'loan', 'debt', 'value', 'estimated value', 'ratio'],

  'Cash Buyer': ['cash', 'money', 'investors', 'buyer', 'cash buyers'],
  'Free & Clear': ['no debt', 'no mortgage', 'paid off', 'clear', 'debt free', 'free & clear'],
  'Seller Carry Back': ['carryback', 'seller financing', 'finance', 'owner financing', 'purchase-money', 'mortgage', 'seller carry back'],

};


function formatDatewithUTC(date) {
  const dateObject = new Date(date);
  const formattedDate = `${(dateObject.getMonth() + 1).toString().padStart(2, '0')}/${dateObject.getDate().toString().padStart(2, '0')}/${dateObject.getFullYear().toString().slice(-2)}`;
  return formattedDate
}

export const formatDateShortWithUTC = (date) => formatDatewithUTC(date);

export const tagSuggestions = ["pre-foreclosure", "sheriff's sale", "auction",
  "date", "time", 'distressed', 'bank', 'bankruptcy',
  'chapter 7', 'chapter 13', 'active', 'dismissed', 'broke', 'liquidation',
  'cash', 'money', 'investors', 'buyer', 'divorce', 'seperation',
  'mls', 'listings', 'removed', 'failure', 'failed', 'fail',
  'flip', 'flippers', 'sold', 'no debt', 'no mortgage', 'paid off',
  'clear', 'debt free', 'equity', 'high equity', 'low debt', 'liens', 'involuntary',
  'listed', 'sale', 'for sale', 'agent', 'realtor',
  'pending', 'contingent', 'lis pendens', 'default', 'notice', "trustee's sale", 'foreclosure',
  'probate', 'pre-probate', 'funeral',
  'cemetary', 'deceased', 'owner', 'transfer', 'senior owners', 'senior', 'old',
  'reverse mortgage', 'age', 'delinquency', 'delinquent', 'federal',
  'property', 'property taxes', 'tax', 'taxes', 'unpaid', 'landlord',
  'non-owner', 'non-owner occupied', 'nonowner', 'rental', 'tenant', 'tired',
  'negative equity', 'underwater', 'vacant', 'usps', 'vacation',
  'home', 'empty', 'land', 'plot', 'lot', 'zombie', 'rent', 'for rent',
  'never listed', 'status', 'dom', 'days on market', 'amount', 'price', 'cost',
  'below market value', 'under', 'value', 'description', 'ownership', 'length of time',
  'individual', 'corporate', 'mixed', 'trust', 'local', 'out of state', 'out of county',
  'state', 'county', 'prior', 'linked properties', 'properties', 'multiple', 'unknown',
  'family', 'exchange', 'no sale', 'intra-family', 'exemption', 'disabled', 'homestead',
  'hospital', 'library', 'religious', 'school', 'utilities', 'veteran', 'welfare',
  'widow', 'no exemption', 'mortgage', 'loan', 'conventional', 'fha', 'va',
  'credit line', 'commercial', 'construction', 'debt', 'loan position', 'origination',
  'payment', 'loan term', 'term', 'interest', 'freddie mac', 'fixed', 'adjustable',
  'variable', 'step interest', 'estimated value', 'ratio', 'percentage', 'carryback',
  'seller financing', 'finance', 'owner financing', 'purchase-money', 'comps', 'assessed',
  'analytics', 'increase', 'decrease', 'income', 'cash flow', 'estimate', 'revenue',
  'before taxes', 'expenses', 'estimated', 'medium equity', 'low equity',
  'under water', 'upside down', 'medium', 'high', 'low', 'assessed value', 'improvement',
  'renovate', 'recording', 'trustee', 'cancelled', 'canceled', 'date time', 'release',
  'lien', 'hoa', 'mechanics', 'utility', 'solar', 'child support', 'voluntary', 'city',
  'released', 'recorded', 'seperated', 'court', '100+', 'storage', 'room', 'adu', 'basement',
  'garage', 'cars', 'truck', 'van', 'swimming', 'pool', 'water', 'coa', 'association', 'monthly',
  'fees', 'building', 'second', 'stories', 'tall', 'floors', 'apartment', 'multi-family', 'units',
  'complex', 'district', 'kid', 'child', 'built', 'size', 'sqft', 'area', 'dimensions', 'parcel',
  'shower', 'toilet', 'bathroom', 'plumbing', 'bedroom', 'sleep', '5+', 'abandoned', 'administration',
  'administrative', 'agricultural', 'airport', 'amusement', 'appliance', 'apt', 'arcades', 'arenas',
  'art', 'assembly', 'asylum', 'auditoriums', 'auto', 'bakery', 'bar', 'barren', 'beach', 'bed', 'billiard',
  'boarding', 'boat', 'bottling', 'bowling', 'breakfast', 'brewery', 'bridges', 'bungalow', 'bus terminal', 'cabin',
  'cable tv', 'campground', 'camps', 'cannery', 'carwash', 'casino', 'centrally assessed',
  'charitable', 'charity', 'chemical', 'children', 'church', 'classifications', 'clinic', 'clubs', 'cluster', 'cocktail',
  'cold storage', 'college', 'communications', 'community', 'condo', 'condominium',
  'contaminated', 'contracting', 'contractor', 'convalescent', 'convenience store', 'convention', 'cooperative', 'correctional',
  'country club', 'crematorium', 'crops', 'cultural', 'dairy', 'dance', 'daycare', 'dental', 'department', 'desert',
  'development', 'diner', 'discount', 'distillery', 'dormitory', 'drive-in', 'drive-thru',
  'drug store', 'dry cleaner', 'dump', 'duplex', 'dwelling', 'emergency', 'enterprise', 'entertainment', 'exempt', 'factory', 'fairgrounds',
  'farm', 'fast food', 'fastfood', 'feedlots', 'financial', 'fire', 'florist', 'forest', 'foundry', 'franchise', 'fraternity', 'freeway',
  'fuel', 'game', 'garden', 'gas', 'gasoline', 'go-carts', 'golf', 'golf course', 'government', 'governmental', 'grain',
  'grazing', 'greenhouse', 'grocery', 'group', 'grove', 'gym', 'handicap', 'harbor', 'health', 'healthcare', 'heavy', 'high-rise', 'highway', 'historical',
  'horse', 'horticulture', 'hotel', 'ice', 'industrial', 'insane', 'institution', 'institutional', 'insurance',
  'irrigation', 'jail', 'junk', 'kennel', 'labor', 'laboratory', 'landominium', 'laundromat', 'laundry', 'legal', 'light', 'liquor',
  'livestock', 'lodging', 'loft', 'lounge', 'low income', 'lumber', 'lumberyard', 'mall', 'manufactured', 'manufacturing', 'marina', 'marsh', 'meadow',
  'medical', 'microwave', 'military', 'mill', 'mini-warehouse', 'miniature', 'mining', 'misc', 'mixed use', 'mobile',
  'modular', 'mortuary', 'motel', 'motor freight', 'mountain', 'multi-family', 'multi-tenant', 'municipal', 'municipality',
  'museums', 'native', 'native american', 'natural resources', 'neighborhood', 'nightclub', 'nursery', 'nursing', 'office', 'open space', 'orchard',
  'organization', 'orphanage', 'outdoor', 'packing', 'paper', 'park', 'parking', 'parlor', 'parochial', 'pasture', 'patio', 'personal', 'pet', 'petroleum',
  'pharmacy', 'photo', 'picnic', 'piers', 'plant', 'playground', 'plaza', 'police', 'pollution', 'post office', 'poultry',
  'pre-fabricate', 'pre-school', 'printer', 'printing', 'prison', 'private', 'private preserve', 'professional', 'public',
  'publishing', 'PUD', 'quadruplex', 'quarries', 'quarry', 'quarters', 'race', 'racquet', 'radio station', 'railroad', 'ranch', 'range', 'real estate',
  'recreation', 'recreational', 'recycling', 'redevelopment', 'refinery', 'rentals', 'repair', 'reservoir', 'residence', 'residential', 'resort',
  'restaurant', 'retail', 'retired', 'riding', 'roller', 'rooming', 'row house', 'rural', 'rv', 'sales', 'salvage', 'sbe', 'seasonal',
  'services', 'sewage', 'shipyard', 'shooting', 'shopping', 'shore', 'single family', 'skating', 'skyscraper', 'slaughter house', 'social', 'social services',
  'sorority', 'spa', 'special assessments', 'special purpose', 'stadiums', 'station', 'stockyard', 'sugar', 'supermarket', 'supplies',
  'supply', 'swamp', 'swimming', 'take-out', 'target', 'tavern', 'telegraph', 'telephone', 'tennis', 'theater', 'timberland',
  'timeshare', 'tourist', 'townhouse', 'trailer park', 'trails', 'transient', 'transportation', 'treatment', 'trees', 'triplex',
  'tv station', 'types', 'under construction', 'unimproved', 'university', 'unusable land', 'vacant land',
  'vehicle', 'veterinary', 'village', 'vineyard', 'warehouse', 'wash', 'waste', 'waste land', 'water supply', 'waterslides',
  'well', 'wharf', 'wholesale', 'wildlife', 'winery', 'wood', 'worship', 'yacht', 'zero lot line', 'zoo', 'auctions', 'bank owned',
  'cash buyers', 'failed listings', 'on market', 'tax delinquency', 'tired landlords', 'zombie properties', 'property classifications',
  'building size', 'lot size', 'year built', 'school district', 'number of units', 'number of stories', 'attic', 'listing type',
  'mls status', 'mls status date', 'listing amount', 'listed below market price', 'keyword search', 'recording date', 'auction date',
  'pre-foreclosure release date', 'opening bid amount', 'default amount', 'years of ownership', 'absentee owner location', 'last sale price',
  'number of properties owned', 'last sale date', 'include unknown sales dates', 'intra-family transfer', 'tax exemption status', 'lien types',
  'lien recording date', 'lien amount', 'tax delinquent year', 'divorce recording date', 'bankruptcy recording date', 'bankruptcy type',
  'assessed land value', 'growth %', 'estimated rental income', 'gross yield %', 'estimated equity $ amount', 'estimated equity %',
  'loan to value (LTV) %', 'assessed total value', 'assessed improvement value', 'improvement to tax value %', 'number of open mortgages',
  'open mortgage remaining balance', 'mortgage recording date', 'loan types', 'total monthly payments', 'interest rate % (Est)', 'interest rate types',
  '1st loan to current value (1LTV) %', '1st loan to current value (1LTV) $', 'cash buyers', 'free & clear', 'seller carry back',
  'overall property condition', 'property condition', 'bathroom condition', 'bathrooms', 'condition', 'kitchen condition', 'kitchen',
  'interior condition', 'interior', 'exterior condition', 'exterior', 'foreclosure factor', 'factor', 'include unknown equity'
];

export const FilterExtraTextDisplay = () => 
  <div className={newsearchfilter.filterExtraText}>Select Include or Exclude to see more options</div>
